(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebe57"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebe57"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("x1Mg0", function(module, exports) {

var $2bfPH = parcelRequire("2bfPH");

var $5x7ME = parcelRequire("5x7ME");
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */ (function(global1, factory) {
    module.exports = factory();
})(undefined, function() {
    "use strict";
    function objectOrFunction(x) {
        var type = typeof x === "undefined" ? "undefined" : (0, $2bfPH._)(x);
        return x !== null && (type === "object" || type === "function");
    }
    function isFunction(x) {
        return typeof x === "function";
    }
    var _isArray = void 0;
    if (Array.isArray) _isArray = Array.isArray;
    else _isArray = function _isArray(x) {
        return Object.prototype.toString.call(x) === "[object Array]";
    };
    var isArray = _isArray;
    var len = 0;
    var vertxNext = void 0;
    var customSchedulerFn = void 0;
    var asap = function asap(callback, arg) {
        queue[len] = callback;
        queue[len + 1] = arg;
        len += 2;
        if (len === 2) {
            // If len is 2, that means that we need to schedule an async flush.
            // If additional callbacks are queued before the queue is flushed, they
            // will be processed by this flush that we are scheduling.
            if (customSchedulerFn) customSchedulerFn(flush);
            else scheduleFlush();
        }
    };
    function setScheduler(scheduleFn) {
        customSchedulerFn = scheduleFn;
    }
    function setAsap(asapFn) {
        asap = asapFn;
    }
    var browserWindow = typeof window !== "undefined" ? window : undefined;
    var browserGlobal = browserWindow || {};
    var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
    var isNode = typeof self === "undefined" && typeof $5x7ME !== "undefined" && ({}).toString.call($5x7ME) === "[object process]";
    // test for web worker but not in IE10
    var isWorker = typeof Uint8ClampedArray !== "undefined" && typeof importScripts !== "undefined" && typeof MessageChannel !== "undefined";
    // node
    function useNextTick() {
        // node version 0.10.x displays a deprecation warning when nextTick is used recursively
        // see https://github.com/cujojs/when/issues/410 for details
        return function() {
            return $5x7ME.nextTick(flush);
        };
    }
    // vertx
    function useVertxTimer() {
        if (typeof vertxNext !== "undefined") return function() {
            vertxNext(flush);
        };
        return useSetTimeout();
    }
    function useMutationObserver() {
        var iterations = 0;
        var observer = new BrowserMutationObserver(flush);
        var node = document.createTextNode("");
        observer.observe(node, {
            characterData: true
        });
        return function() {
            node.data = iterations = ++iterations % 2;
        };
    }
    // web worker
    function useMessageChannel() {
        var channel = new MessageChannel();
        channel.port1.onmessage = flush;
        return function() {
            return channel.port2.postMessage(0);
        };
    }
    function useSetTimeout() {
        // Store setTimeout reference so es6-promise will be unaffected by
        // other code modifying setTimeout (like sinon.useFakeTimers())
        var globalSetTimeout = setTimeout;
        return function() {
            return globalSetTimeout(flush, 1);
        };
    }
    var queue = new Array(1000);
    function flush() {
        for(var i = 0; i < len; i += 2){
            var callback = queue[i];
            var arg = queue[i + 1];
            callback(arg);
            queue[i] = undefined;
            queue[i + 1] = undefined;
        }
        len = 0;
    }
    function attemptVertx() {
        try {
            var vertx = Function("return this")().require("vertx");
            vertxNext = vertx.runOnLoop || vertx.runOnContext;
            return useVertxTimer();
        } catch (e) {
            return useSetTimeout();
        }
    }
    var scheduleFlush = void 0;
    // Decide what async method to use to triggering processing of queued callbacks:
    if (isNode) scheduleFlush = useNextTick();
    else if (BrowserMutationObserver) scheduleFlush = useMutationObserver();
    else if (isWorker) scheduleFlush = useMessageChannel();
    else if (browserWindow === undefined && true) scheduleFlush = attemptVertx();
    else scheduleFlush = useSetTimeout();
    function then(onFulfillment, onRejection) {
        var parent = this;
        var child = new this.constructor(noop);
        if (child[PROMISE_ID] === undefined) makePromise(child);
        var _state = parent._state;
        if (_state) {
            var callback = arguments[_state - 1];
            asap(function() {
                return invokeCallback(_state, child, callback, parent._result);
            });
        } else subscribe(parent, child, onFulfillment, onRejection);
        return child;
    }
    /**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$1(object) {
        /*jshint validthis:true */ var Constructor = this;
        if (object && typeof object === "object" && object.constructor === Constructor) return object;
        var promise = new Constructor(noop);
        resolve(promise, object);
        return promise;
    }
    var PROMISE_ID = Math.random().toString(36).substring(2);
    function noop() {}
    var PENDING = void 0;
    var FULFILLED = 1;
    var REJECTED = 2;
    function selfFulfillment() {
        return new TypeError("You cannot resolve a promise with itself");
    }
    function cannotReturnOwn() {
        return new TypeError("A promises callback cannot return that same promise.");
    }
    function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
        try {
            then$$1.call(value, fulfillmentHandler, rejectionHandler);
        } catch (e) {
            return e;
        }
    }
    function handleForeignThenable(promise, thenable, then$$1) {
        asap(function(promise) {
            var sealed = false;
            var error = tryThen(then$$1, thenable, function(value) {
                if (sealed) return;
                sealed = true;
                if (thenable !== value) resolve(promise, value);
                else fulfill(promise, value);
            }, function(reason) {
                if (sealed) return;
                sealed = true;
                reject(promise, reason);
            }, "Settle: " + (promise._label || " unknown promise"));
            if (!sealed && error) {
                sealed = true;
                reject(promise, error);
            }
        }, promise);
    }
    function handleOwnThenable(promise, thenable) {
        if (thenable._state === FULFILLED) fulfill(promise, thenable._result);
        else if (thenable._state === REJECTED) reject(promise, thenable._result);
        else subscribe(thenable, undefined, function(value) {
            return resolve(promise, value);
        }, function(reason) {
            return reject(promise, reason);
        });
    }
    function handleMaybeThenable(promise, maybeThenable, then$$1) {
        if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) handleOwnThenable(promise, maybeThenable);
        else {
            if (then$$1 === undefined) fulfill(promise, maybeThenable);
            else if (isFunction(then$$1)) handleForeignThenable(promise, maybeThenable, then$$1);
            else fulfill(promise, maybeThenable);
        }
    }
    function resolve(promise, value) {
        if (promise === value) reject(promise, selfFulfillment());
        else if (objectOrFunction(value)) {
            var then$$1 = void 0;
            try {
                then$$1 = value.then;
            } catch (error) {
                reject(promise, error);
                return;
            }
            handleMaybeThenable(promise, value, then$$1);
        } else fulfill(promise, value);
    }
    function publishRejection(promise) {
        if (promise._onerror) promise._onerror(promise._result);
        publish(promise);
    }
    function fulfill(promise, value) {
        if (promise._state !== PENDING) return;
        promise._result = value;
        promise._state = FULFILLED;
        if (promise._subscribers.length !== 0) asap(publish, promise);
    }
    function reject(promise, reason) {
        if (promise._state !== PENDING) return;
        promise._state = REJECTED;
        promise._result = reason;
        asap(publishRejection, promise);
    }
    function subscribe(parent, child, onFulfillment, onRejection) {
        var _subscribers = parent._subscribers;
        var length = _subscribers.length;
        parent._onerror = null;
        _subscribers[length] = child;
        _subscribers[length + FULFILLED] = onFulfillment;
        _subscribers[length + REJECTED] = onRejection;
        if (length === 0 && parent._state) asap(publish, parent);
    }
    function publish(promise) {
        var subscribers = promise._subscribers;
        var settled = promise._state;
        if (subscribers.length === 0) return;
        var child = void 0, callback = void 0, detail = promise._result;
        for(var i = 0; i < subscribers.length; i += 3){
            child = subscribers[i];
            callback = subscribers[i + settled];
            if (child) invokeCallback(settled, child, callback, detail);
            else callback(detail);
        }
        promise._subscribers.length = 0;
    }
    function invokeCallback(settled, promise, callback, detail) {
        var hasCallback = isFunction(callback), value = void 0, error = void 0, succeeded = true;
        if (hasCallback) {
            try {
                value = callback(detail);
            } catch (e) {
                succeeded = false;
                error = e;
            }
            if (promise === value) {
                reject(promise, cannotReturnOwn());
                return;
            }
        } else value = detail;
        if (promise._state !== PENDING) ;
        else if (hasCallback && succeeded) resolve(promise, value);
        else if (succeeded === false) reject(promise, error);
        else if (settled === FULFILLED) fulfill(promise, value);
        else if (settled === REJECTED) reject(promise, value);
    }
    function initializePromise(promise, resolver) {
        try {
            resolver(function resolvePromise(value) {
                resolve(promise, value);
            }, function rejectPromise(reason) {
                reject(promise, reason);
            });
        } catch (e) {
            reject(promise, e);
        }
    }
    var id = 0;
    function nextId() {
        return id++;
    }
    function makePromise(promise) {
        promise[PROMISE_ID] = id++;
        promise._state = undefined;
        promise._result = undefined;
        promise._subscribers = [];
    }
    function validationError() {
        return new Error("Array Methods must be provided an Array");
    }
    var Enumerator = function() {
        function Enumerator(Constructor, input) {
            this._instanceConstructor = Constructor;
            this.promise = new Constructor(noop);
            if (!this.promise[PROMISE_ID]) makePromise(this.promise);
            if (isArray(input)) {
                this.length = input.length;
                this._remaining = input.length;
                this._result = new Array(this.length);
                if (this.length === 0) fulfill(this.promise, this._result);
                else {
                    this.length = this.length || 0;
                    this._enumerate(input);
                    if (this._remaining === 0) fulfill(this.promise, this._result);
                }
            } else reject(this.promise, validationError());
        }
        Enumerator.prototype._enumerate = function _enumerate(input) {
            for(var i = 0; this._state === PENDING && i < input.length; i++)this._eachEntry(input[i], i);
        };
        Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
            var c = this._instanceConstructor;
            var resolve$$1 = c.resolve;
            if (resolve$$1 === resolve$1) {
                var _then = void 0;
                var error = void 0;
                var didError = false;
                try {
                    _then = entry.then;
                } catch (e) {
                    didError = true;
                    error = e;
                }
                if (_then === then && entry._state !== PENDING) this._settledAt(entry._state, i, entry._result);
                else if (typeof _then !== "function") {
                    this._remaining--;
                    this._result[i] = entry;
                } else if (c === Promise$1) {
                    var promise = new c(noop);
                    if (didError) reject(promise, error);
                    else handleMaybeThenable(promise, entry, _then);
                    this._willSettleAt(promise, i);
                } else this._willSettleAt(new c(function(resolve$$1) {
                    return resolve$$1(entry);
                }), i);
            } else this._willSettleAt(resolve$$1(entry), i);
        };
        Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
            var promise = this.promise;
            if (promise._state === PENDING) {
                this._remaining--;
                if (state === REJECTED) reject(promise, value);
                else this._result[i] = value;
            }
            if (this._remaining === 0) fulfill(promise, this._result);
        };
        Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
            var enumerator = this;
            subscribe(promise, undefined, function(value) {
                return enumerator._settledAt(FULFILLED, i, value);
            }, function(reason) {
                return enumerator._settledAt(REJECTED, i, reason);
            });
        };
        return Enumerator;
    }();
    /**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/ function all(entries) {
        return new Enumerator(this, entries).promise;
    }
    /**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/ function race(entries) {
        /*jshint validthis:true */ var Constructor = this;
        if (!isArray(entries)) return new Constructor(function(_, reject) {
            return reject(new TypeError("You must pass an array to race."));
        });
        else return new Constructor(function(resolve, reject) {
            var length = entries.length;
            for(var i = 0; i < length; i++)Constructor.resolve(entries[i]).then(resolve, reject);
        });
    }
    /**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$1(reason) {
        /*jshint validthis:true */ var Constructor = this;
        var promise = new Constructor(noop);
        reject(promise, reason);
        return promise;
    }
    function needsResolver() {
        throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
    }
    function needsNew() {
        throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    }
    /**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/ var Promise$1 = function() {
        function Promise(resolver) {
            this[PROMISE_ID] = nextId();
            this._result = this._state = undefined;
            this._subscribers = [];
            if (noop !== resolver) {
                typeof resolver !== "function" && needsResolver();
                this instanceof Promise ? initializePromise(this, resolver) : needsNew();
            }
        }
        /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */ /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */ Promise.prototype.catch = function _catch(onRejection) {
            return this.then(null, onRejection);
        };
        /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */ Promise.prototype.finally = function _finally(callback) {
            var promise = this;
            var constructor = promise.constructor;
            if (isFunction(callback)) return promise.then(function(value) {
                return constructor.resolve(callback()).then(function() {
                    return value;
                });
            }, function(reason) {
                return constructor.resolve(callback()).then(function() {
                    throw reason;
                });
            });
            return promise.then(callback, callback);
        };
        return Promise;
    }();
    Promise$1.prototype.then = then;
    Promise$1.all = all;
    Promise$1.race = race;
    Promise$1.resolve = resolve$1;
    Promise$1.reject = reject$1;
    Promise$1._setScheduler = setScheduler;
    Promise$1._setAsap = setAsap;
    Promise$1._asap = asap;
    /*global self*/ function polyfill() {
        var local = void 0;
        if (typeof $parcel$global !== "undefined") local = $parcel$global;
        else if (typeof self !== "undefined") local = self;
        else try {
            local = Function("return this")();
        } catch (e) {
            throw new Error("polyfill failed because global object is unavailable in this environment");
        }
        var P = local.Promise;
        if (P) {
            var promiseToString = null;
            try {
                promiseToString = Object.prototype.toString.call(P.resolve());
            } catch (e) {
            // silently ignored
            }
            if (promiseToString === "[object Promise]" && !P.cast) return;
        }
        local.Promise = Promise$1;
    }
    // Strange compat..
    Promise$1.polyfill = polyfill;
    Promise$1.Promise = Promise$1;
    return Promise$1;
});

});
parcelRegister("2bfPH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1968e3edfc5cfc11$export$5f0017c582d45a2d; });
function $1968e3edfc5cfc11$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("5x7ME", function(module, exports) {
// shim for using process in browser
var $40761280b577a31b$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $40761280b577a31b$var$cachedSetTimeout;
var $40761280b577a31b$var$cachedClearTimeout;
function $40761280b577a31b$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $40761280b577a31b$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $40761280b577a31b$var$cachedSetTimeout = setTimeout;
        else $40761280b577a31b$var$cachedSetTimeout = $40761280b577a31b$var$defaultSetTimout;
    } catch (e) {
        $40761280b577a31b$var$cachedSetTimeout = $40761280b577a31b$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $40761280b577a31b$var$cachedClearTimeout = clearTimeout;
        else $40761280b577a31b$var$cachedClearTimeout = $40761280b577a31b$var$defaultClearTimeout;
    } catch (e) {
        $40761280b577a31b$var$cachedClearTimeout = $40761280b577a31b$var$defaultClearTimeout;
    }
})();
function $40761280b577a31b$var$runTimeout(fun) {
    if ($40761280b577a31b$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($40761280b577a31b$var$cachedSetTimeout === $40761280b577a31b$var$defaultSetTimout || !$40761280b577a31b$var$cachedSetTimeout) && setTimeout) {
        $40761280b577a31b$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $40761280b577a31b$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $40761280b577a31b$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $40761280b577a31b$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $40761280b577a31b$var$runClearTimeout(marker) {
    if ($40761280b577a31b$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($40761280b577a31b$var$cachedClearTimeout === $40761280b577a31b$var$defaultClearTimeout || !$40761280b577a31b$var$cachedClearTimeout) && clearTimeout) {
        $40761280b577a31b$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $40761280b577a31b$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $40761280b577a31b$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $40761280b577a31b$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $40761280b577a31b$var$queue = [];
var $40761280b577a31b$var$draining = false;
var $40761280b577a31b$var$currentQueue;
var $40761280b577a31b$var$queueIndex = -1;
function $40761280b577a31b$var$cleanUpNextTick() {
    if (!$40761280b577a31b$var$draining || !$40761280b577a31b$var$currentQueue) return;
    $40761280b577a31b$var$draining = false;
    if ($40761280b577a31b$var$currentQueue.length) $40761280b577a31b$var$queue = $40761280b577a31b$var$currentQueue.concat($40761280b577a31b$var$queue);
    else $40761280b577a31b$var$queueIndex = -1;
    if ($40761280b577a31b$var$queue.length) $40761280b577a31b$var$drainQueue();
}
function $40761280b577a31b$var$drainQueue() {
    if ($40761280b577a31b$var$draining) return;
    var timeout = $40761280b577a31b$var$runTimeout($40761280b577a31b$var$cleanUpNextTick);
    $40761280b577a31b$var$draining = true;
    var len = $40761280b577a31b$var$queue.length;
    while(len){
        $40761280b577a31b$var$currentQueue = $40761280b577a31b$var$queue;
        $40761280b577a31b$var$queue = [];
        while(++$40761280b577a31b$var$queueIndex < len)if ($40761280b577a31b$var$currentQueue) $40761280b577a31b$var$currentQueue[$40761280b577a31b$var$queueIndex].run();
        $40761280b577a31b$var$queueIndex = -1;
        len = $40761280b577a31b$var$queue.length;
    }
    $40761280b577a31b$var$currentQueue = null;
    $40761280b577a31b$var$draining = false;
    $40761280b577a31b$var$runClearTimeout(timeout);
}
$40761280b577a31b$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $40761280b577a31b$var$queue.push(new $40761280b577a31b$var$Item(fun, args));
    if ($40761280b577a31b$var$queue.length === 1 && !$40761280b577a31b$var$draining) $40761280b577a31b$var$runTimeout($40761280b577a31b$var$drainQueue);
};
// v8 likes predictible objects
function $40761280b577a31b$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$40761280b577a31b$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$40761280b577a31b$var$process.title = "browser";
$40761280b577a31b$var$process.browser = true;
$40761280b577a31b$var$process.env = {};
$40761280b577a31b$var$process.argv = [];
$40761280b577a31b$var$process.version = ""; // empty string to avoid regexp issues
$40761280b577a31b$var$process.versions = {};
function $40761280b577a31b$var$noop() {}
$40761280b577a31b$var$process.on = $40761280b577a31b$var$noop;
$40761280b577a31b$var$process.addListener = $40761280b577a31b$var$noop;
$40761280b577a31b$var$process.once = $40761280b577a31b$var$noop;
$40761280b577a31b$var$process.off = $40761280b577a31b$var$noop;
$40761280b577a31b$var$process.removeListener = $40761280b577a31b$var$noop;
$40761280b577a31b$var$process.removeAllListeners = $40761280b577a31b$var$noop;
$40761280b577a31b$var$process.emit = $40761280b577a31b$var$noop;
$40761280b577a31b$var$process.prependListener = $40761280b577a31b$var$noop;
$40761280b577a31b$var$process.prependOnceListener = $40761280b577a31b$var$noop;
$40761280b577a31b$var$process.listeners = function(name) {
    return [];
};
$40761280b577a31b$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$40761280b577a31b$var$process.cwd = function() {
    return "/";
};
$40761280b577a31b$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$40761280b577a31b$var$process.umask = function() {
    return 0;
};

});


parcelRegister("03SX2", function(module, exports) {
"use strict";

var $50lQ1 = parcelRequire("50lQ1");

var $2k7af = parcelRequire("2k7af");

var $hpQ52 = parcelRequire("hpQ52");

var $dYooA = parcelRequire("dYooA");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $00bae815612f32bf$var$createInstance(defaultConfig) {
    var context = new $hpQ52(defaultConfig);
    var instance = $2k7af($hpQ52.prototype.request, context);
    // Copy axios.prototype to instance
    $50lQ1.extend(instance, $hpQ52.prototype, context);
    // Copy context to instance
    $50lQ1.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $00bae815612f32bf$var$axios = $00bae815612f32bf$var$createInstance($dYooA);
// Expose Axios class to allow class inheritance
$00bae815612f32bf$var$axios.Axios = $hpQ52;
// Factory for creating new instances
$00bae815612f32bf$var$axios.create = function create(instanceConfig) {
    return $00bae815612f32bf$var$createInstance($50lQ1.merge($dYooA, instanceConfig));
};

// Expose Cancel & CancelToken
$00bae815612f32bf$var$axios.Cancel = (parcelRequire("fopkD"));

$00bae815612f32bf$var$axios.CancelToken = (parcelRequire("jpdXe"));

$00bae815612f32bf$var$axios.isCancel = (parcelRequire("itdvL"));
// Expose all/spread
$00bae815612f32bf$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$00bae815612f32bf$var$axios.spread = (parcelRequire("3qhsn"));
module.exports = $00bae815612f32bf$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $00bae815612f32bf$var$axios;

});
parcelRegister("50lQ1", function(module, exports) {
"use strict";

var $2k7af = parcelRequire("2k7af");

var $8cf1w = parcelRequire("8cf1w");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $3a4de46bd2d3d207$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $3a4de46bd2d3d207$var$isArray(val) {
    return $3a4de46bd2d3d207$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $3a4de46bd2d3d207$var$isArrayBuffer(val) {
    return $3a4de46bd2d3d207$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $3a4de46bd2d3d207$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $3a4de46bd2d3d207$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $3a4de46bd2d3d207$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $3a4de46bd2d3d207$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $3a4de46bd2d3d207$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $3a4de46bd2d3d207$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $3a4de46bd2d3d207$var$isDate(val) {
    return $3a4de46bd2d3d207$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $3a4de46bd2d3d207$var$isFile(val) {
    return $3a4de46bd2d3d207$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $3a4de46bd2d3d207$var$isBlob(val) {
    return $3a4de46bd2d3d207$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $3a4de46bd2d3d207$var$isFunction(val) {
    return $3a4de46bd2d3d207$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $3a4de46bd2d3d207$var$isStream(val) {
    return $3a4de46bd2d3d207$var$isObject(val) && $3a4de46bd2d3d207$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $3a4de46bd2d3d207$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $3a4de46bd2d3d207$var$trim(str) {
    return str.replace(/^\s*/, "").replace(/\s*$/, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */ function $3a4de46bd2d3d207$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && navigator.product === "ReactNative") return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $3a4de46bd2d3d207$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($3a4de46bd2d3d207$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $3a4de46bd2d3d207$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === "object" && typeof val === "object") result[key] = $3a4de46bd2d3d207$var$merge(result[key], val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$3a4de46bd2d3d207$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $3a4de46bd2d3d207$var$extend(a, b, thisArg) {
    $3a4de46bd2d3d207$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $2k7af(val, thisArg);
        else a[key] = val;
    });
    return a;
}
module.exports = {
    isArray: $3a4de46bd2d3d207$var$isArray,
    isArrayBuffer: $3a4de46bd2d3d207$var$isArrayBuffer,
    isBuffer: $8cf1w,
    isFormData: $3a4de46bd2d3d207$var$isFormData,
    isArrayBufferView: $3a4de46bd2d3d207$var$isArrayBufferView,
    isString: $3a4de46bd2d3d207$var$isString,
    isNumber: $3a4de46bd2d3d207$var$isNumber,
    isObject: $3a4de46bd2d3d207$var$isObject,
    isUndefined: $3a4de46bd2d3d207$var$isUndefined,
    isDate: $3a4de46bd2d3d207$var$isDate,
    isFile: $3a4de46bd2d3d207$var$isFile,
    isBlob: $3a4de46bd2d3d207$var$isBlob,
    isFunction: $3a4de46bd2d3d207$var$isFunction,
    isStream: $3a4de46bd2d3d207$var$isStream,
    isURLSearchParams: $3a4de46bd2d3d207$var$isURLSearchParams,
    isStandardBrowserEnv: $3a4de46bd2d3d207$var$isStandardBrowserEnv,
    forEach: $3a4de46bd2d3d207$var$forEach,
    merge: $3a4de46bd2d3d207$var$merge,
    extend: $3a4de46bd2d3d207$var$extend,
    trim: $3a4de46bd2d3d207$var$trim
};

});
parcelRegister("2k7af", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});

parcelRegister("8cf1w", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ module.exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};

});


parcelRegister("hpQ52", function(module, exports) {
"use strict";

var $dYooA = parcelRequire("dYooA");

var $50lQ1 = parcelRequire("50lQ1");

var $9pMgu = parcelRequire("9pMgu");

var $c7wPW = parcelRequire("c7wPW");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $cadd2b8bf935de77$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $9pMgu(),
        response: new $9pMgu()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $cadd2b8bf935de77$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") config = $50lQ1.merge({
        url: arguments[0]
    }, arguments[1]);
    config = $50lQ1.merge($dYooA, {
        method: "get"
    }, this.defaults, config);
    config.method = config.method.toLowerCase();
    // Hook up interceptors middleware
    var chain = [
        $c7wPW,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
// Provide aliases for supported request methods
$50lQ1.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cadd2b8bf935de77$var$Axios.prototype[method] = function(url, config) {
        return this.request($50lQ1.merge(config || {}, {
            method: method,
            url: url
        }));
    };
});
$50lQ1.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $cadd2b8bf935de77$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($50lQ1.merge(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $cadd2b8bf935de77$var$Axios;

});
parcelRegister("dYooA", function(module, exports) {

var $5x7ME = parcelRequire("5x7ME");
"use strict";

var $50lQ1 = parcelRequire("50lQ1");

var $gRBKw = parcelRequire("gRBKw");
var $a2c3cd6236805a39$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $a2c3cd6236805a39$var$setContentTypeIfUnset(headers, value) {
    if (!$50lQ1.isUndefined(headers) && $50lQ1.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $a2c3cd6236805a39$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("iAPCZ"));
    else if (typeof $5x7ME !== "undefined") // For node use HTTP adapter
    adapter = (parcelRequire("iAPCZ"));
    return adapter;
}
var $a2c3cd6236805a39$var$defaults = {
    adapter: $a2c3cd6236805a39$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $gRBKw(headers, "Content-Type");
            if ($50lQ1.isFormData(data) || $50lQ1.isArrayBuffer(data) || $50lQ1.isBuffer(data) || $50lQ1.isStream(data) || $50lQ1.isFile(data) || $50lQ1.isBlob(data)) return data;
            if ($50lQ1.isArrayBufferView(data)) return data.buffer;
            if ($50lQ1.isURLSearchParams(data)) {
                $a2c3cd6236805a39$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($50lQ1.isObject(data)) {
                $a2c3cd6236805a39$var$setContentTypeIfUnset(headers, "application/json;charset=utf-8");
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === "string") try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$a2c3cd6236805a39$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$50lQ1.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $a2c3cd6236805a39$var$defaults.headers[method] = {};
});
$50lQ1.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $a2c3cd6236805a39$var$defaults.headers[method] = $50lQ1.merge($a2c3cd6236805a39$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $a2c3cd6236805a39$var$defaults;

});
parcelRegister("gRBKw", function(module, exports) {
"use strict";

var $50lQ1 = parcelRequire("50lQ1");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $50lQ1.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("iAPCZ", function(module, exports) {
"use strict";

var $50lQ1 = parcelRequire("50lQ1");

var $kLTdN = parcelRequire("kLTdN");

var $zDpyA = parcelRequire("zDpyA");

var $e4tRu = parcelRequire("e4tRu");

var $2LK59 = parcelRequire("2LK59");

var $dGpeI = parcelRequire("dGpeI");

module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($50lQ1.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password || "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        request.open(config.method.toUpperCase(), $zDpyA(config.url, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $e4tRu(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === "text" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $kLTdN(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($dGpeI("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            reject($dGpeI("timeout of " + config.timeout + "ms exceeded", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($50lQ1.isStandardBrowserEnv()) {
            var cookies = (parcelRequire("p6DUc"));
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $2LK59(config.url)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $50lQ1.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (config.withCredentials) request.withCredentials = true;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== "json") throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (requestData === undefined) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("kLTdN", function(module, exports) {
"use strict";

var $dGpeI = parcelRequire("dGpeI");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    // Note: status is not exposed by XDomainRequest
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($dGpeI("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("dGpeI", function(module, exports) {
"use strict";

var $1wLbG = parcelRequire("1wLbG");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $1wLbG(error, config, code, request, response);
};

});
parcelRegister("1wLbG", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    return error;
};

});



parcelRegister("zDpyA", function(module, exports) {
"use strict";

var $50lQ1 = parcelRequire("50lQ1");
function $06b1d73e713c56eb$var$encode(val) {
    return encodeURIComponent(val).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($50lQ1.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $50lQ1.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($50lQ1.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $50lQ1.forEach(val, function parseValue(v) {
                if ($50lQ1.isDate(v)) v = v.toISOString();
                else if ($50lQ1.isObject(v)) v = JSON.stringify(v);
                parts.push($06b1d73e713c56eb$var$encode(key) + "=" + $06b1d73e713c56eb$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    return url;
};

});

parcelRegister("e4tRu", function(module, exports) {
"use strict";

var $50lQ1 = parcelRequire("50lQ1");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $a3e89a53ea0e856d$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $50lQ1.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $50lQ1.trim(line.substr(0, i)).toLowerCase();
        val = $50lQ1.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $a3e89a53ea0e856d$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("2LK59", function(module, exports) {
"use strict";

var $50lQ1 = parcelRequire("50lQ1");
module.exports = $50lQ1.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $50lQ1.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("p6DUc", function(module, exports) {
"use strict";

var $50lQ1 = parcelRequire("50lQ1");
module.exports = $50lQ1.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($50lQ1.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($50lQ1.isString(path)) cookie.push("path=" + path);
            if ($50lQ1.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});



parcelRegister("9pMgu", function(module, exports) {
"use strict";

var $50lQ1 = parcelRequire("50lQ1");
function $6dabe340a72bef76$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $6dabe340a72bef76$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $6dabe340a72bef76$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $6dabe340a72bef76$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $50lQ1.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $6dabe340a72bef76$var$InterceptorManager;

});

parcelRegister("c7wPW", function(module, exports) {
"use strict";

var $50lQ1 = parcelRequire("50lQ1");

var $b1TOh = parcelRequire("b1TOh");

var $itdvL = parcelRequire("itdvL");

var $dYooA = parcelRequire("dYooA");

var $5ofvt = parcelRequire("5ofvt");

var $1729Z = parcelRequire("1729Z");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $8d2f9c2e2db62612$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $8d2f9c2e2db62612$var$throwIfCancellationRequested(config);
    // Support baseURL config
    if (config.baseURL && !$5ofvt(config.url)) config.url = $1729Z(config.baseURL, config.url);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $b1TOh(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $50lQ1.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});
    $50lQ1.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $dYooA.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $8d2f9c2e2db62612$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $b1TOh(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$itdvL(reason)) {
            $8d2f9c2e2db62612$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $b1TOh(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("b1TOh", function(module, exports) {
"use strict";

var $50lQ1 = parcelRequire("50lQ1");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $50lQ1.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("itdvL", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("5ofvt", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("1729Z", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});



parcelRegister("fopkD", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $b34cbf496ed00aae$var$Cancel(message) {
    this.message = message;
}
$b34cbf496ed00aae$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$b34cbf496ed00aae$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $b34cbf496ed00aae$var$Cancel;

});

parcelRegister("jpdXe", function(module, exports) {
"use strict";

var $fopkD = parcelRequire("fopkD");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $e20b2d2817632610$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $fopkD(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $e20b2d2817632610$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $e20b2d2817632610$var$CancelToken.source = function source() {
    var cancel;
    var token = new $e20b2d2817632610$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $e20b2d2817632610$var$CancelToken;

});

parcelRegister("3qhsn", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});


// Import SASS

/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */ (function() {
    var container, button, menu, links, subMenus, i, len;
    container = document.getElementById("site-navigation");
    if (!container) return;
    button = container.getElementsByTagName("button")[0];
    if ("undefined" === typeof button) return;
    menu = container.getElementsByTagName("ul")[0];
    // Hide menu toggle button if menu is empty and return early.
    if ("undefined" === typeof menu) {
        button.style.display = "none";
        return;
    }
    menu.setAttribute("aria-expanded", "false");
    if (-1 === menu.className.indexOf("nav-menu")) menu.className += " nav-menu";
    button.onclick = function() {
        if (-1 !== container.className.indexOf("toggled")) {
            container.className = container.className.replace(" toggled", "");
            button.setAttribute("aria-expanded", "false");
            menu.setAttribute("aria-expanded", "false");
        } else {
            container.className += " toggled";
            button.setAttribute("aria-expanded", "true");
            menu.setAttribute("aria-expanded", "true");
        }
    };
    // Get all the link elements within the menu.
    links = menu.getElementsByTagName("a");
    subMenus = menu.getElementsByTagName("ul");
    // Set menu items with submenus to aria-haspopup="true".
    for(i = 0, len = subMenus.length; i < len; i++)subMenus[i].parentNode.setAttribute("aria-haspopup", "true");
    // Each time a menu link is focused or blurred, toggle focus.
    for(i = 0, len = links.length; i < len; i++){
        links[i].addEventListener("focus", toggleFocus, true);
        links[i].addEventListener("blur", toggleFocus, true);
    }
    /**
	 * Sets or removes .focus class on an element.
	 */ function toggleFocus() {
        var self = this;
        // Move up through the ancestors of the current link until we hit .nav-menu.
        while(-1 === self.className.indexOf("nav-menu")){
            // On li elements toggle the class .focus.
            if ("li" === self.tagName.toLowerCase()) {
                if (-1 !== self.className.indexOf("focus")) self.className = self.className.replace(" focus", "");
                else self.className += " focus";
            }
            self = self.parentElement;
        }
    }
    /**
	 * Toggles `focus` class to allow submenu access on tablets.
	 */ (function(container) {
        var touchStartFn, i, parentLink = container.querySelectorAll(".menu-item-has-children > a, .page_item_has_children > a");
        if ("ontouchstart" in window) {
            touchStartFn = function touchStartFn(e) {
                var menuItem = this.parentNode, i;
                if (!menuItem.classList.contains("focus")) {
                    e.preventDefault();
                    for(i = 0; i < menuItem.parentNode.children.length; ++i){
                        if (menuItem === menuItem.parentNode.children[i]) continue;
                        menuItem.parentNode.children[i].classList.remove("focus");
                    }
                    menuItem.classList.add("focus");
                } else menuItem.classList.remove("focus");
            };
            for(i = 0; i < parentLink.length; ++i)parentLink[i].addEventListener("touchstart", touchStartFn, false);
        }
    })(container);
})();


/*
 * jQuery FlexSlider v2.6.1
 * Copyright 2012 WooThemes
 * Contributing Author: Tyler Smith
 */ !function($) {
    var e = !0;
    $.flexslider = function(t, a) {
        var n = $(t);
        n.vars = $.extend({}, $.flexslider.defaults, a);
        var i = n.vars.namespace, s = window.navigator && window.navigator.msPointerEnabled && window.MSGesture, r = ("ontouchstart" in window || s || window.DocumentTouch && document instanceof DocumentTouch) && n.vars.touch, o = "click touchend MSPointerUp keyup", l = "", c, d = "vertical" === n.vars.direction, u = n.vars.reverse, v = n.vars.itemWidth > 0, p = "fade" === n.vars.animation, m = "" !== n.vars.asNavFor, f = {};
        $.data(t, "flexslider", n), f = {
            init: function init() {
                n.animating = !1, n.currentSlide = parseInt(n.vars.startAt ? n.vars.startAt : 0, 10), isNaN(n.currentSlide) && (n.currentSlide = 0), n.animatingTo = n.currentSlide, n.atEnd = 0 === n.currentSlide || n.currentSlide === n.last, n.containerSelector = n.vars.selector.substr(0, n.vars.selector.search(" ")), n.slides = $(n.vars.selector, n), n.container = $(n.containerSelector, n), n.count = n.slides.length, n.syncExists = $(n.vars.sync).length > 0, "slide" === n.vars.animation && (n.vars.animation = "swing"), n.prop = d ? "top" : "marginLeft", n.args = {}, n.manualPause = !1, n.stopped = !1, n.started = !1, n.startTimeout = null, n.transitions = !n.vars.video && !p && n.vars.useCSS && function() {
                    var e = document.createElement("div"), _$t = [
                        "perspectiveProperty",
                        "WebkitPerspective",
                        "MozPerspective",
                        "OPerspective",
                        "msPerspective"
                    ];
                    for(var _$a in _$t)if (void 0 !== e.style[_$t[_$a]]) return n.pfx = _$t[_$a].replace("Perspective", "").toLowerCase(), n.prop = "-" + n.pfx + "-transform", !0;
                    return !1;
                }(), n.ensureAnimationEnd = "", "" !== n.vars.controlsContainer && (n.controlsContainer = $(n.vars.controlsContainer).length > 0 && $(n.vars.controlsContainer)), "" !== n.vars.manualControls && (n.manualControls = $(n.vars.manualControls).length > 0 && $(n.vars.manualControls)), "" !== n.vars.customDirectionNav && (n.customDirectionNav = 2 === $(n.vars.customDirectionNav).length && $(n.vars.customDirectionNav)), n.vars.randomize && (n.slides.sort(function() {
                    return Math.round(Math.random()) - .5;
                }), n.container.empty().append(n.slides)), n.doMath(), n.setup("init"), n.vars.controlNav && f.controlNav.setup(), n.vars.directionNav && f.directionNav.setup(), n.vars.keyboard && (1 === $(n.containerSelector).length || n.vars.multipleKeyboard) && $(document).bind("keyup", function(e) {
                    var _$t = e.keyCode;
                    if (!n.animating && (39 === _$t || 37 === _$t)) {
                        var _$a = 39 === _$t ? n.getTarget("next") : 37 === _$t ? n.getTarget("prev") : !1;
                        n.flexAnimate(_$a, n.vars.pauseOnAction);
                    }
                }), n.vars.mousewheel && n.bind("mousewheel", function(e, t, a, i) {
                    e.preventDefault();
                    var s = 0 > t ? n.getTarget("next") : n.getTarget("prev");
                    n.flexAnimate(s, n.vars.pauseOnAction);
                }), n.vars.pausePlay && f.pausePlay.setup(), n.vars.slideshow && n.vars.pauseInvisible && f.pauseInvisible.init(), n.vars.slideshow && (n.vars.pauseOnHover && n.hover(function() {
                    n.manualPlay || n.manualPause || n.pause();
                }, function() {
                    n.manualPause || n.manualPlay || n.stopped || n.play();
                }), n.vars.pauseInvisible && f.pauseInvisible.isHidden() || (n.vars.initDelay > 0 ? n.startTimeout = setTimeout(n.play, n.vars.initDelay) : n.play())), m && f.asNav.setup(), r && n.vars.touch && f.touch(), (!p || p && n.vars.smoothHeight) && $(window).bind("resize orientationchange focus", f.resize), n.find("img").attr("draggable", "false"), setTimeout(function() {
                    n.vars.start(n);
                }, 200);
            },
            asNav: {
                setup: function setup() {
                    n.asNav = !0, n.animatingTo = Math.floor(n.currentSlide / n.move), n.currentItem = n.currentSlide, n.slides.removeClass(i + "active-slide").eq(n.currentItem).addClass(i + "active-slide"), s ? (t._slider = n, n.slides.each(function() {
                        var e = this;
                        e._gesture = new MSGesture, e._gesture.target = e, e.addEventListener("MSPointerDown", function(e) {
                            e.preventDefault(), e.currentTarget._gesture && e.currentTarget._gesture.addPointer(e.pointerId);
                        }, !1), e.addEventListener("MSGestureTap", function(e) {
                            e.preventDefault();
                            var _$t = $(this), _$a = _$t.index();
                            $(n.vars.asNavFor).data("flexslider").animating || _$t.hasClass("active") || (n.direction = n.currentItem < _$a ? "next" : "prev", n.flexAnimate(_$a, n.vars.pauseOnAction, !1, !0, !0));
                        });
                    })) : n.slides.on(o, function(e) {
                        e.preventDefault();
                        var _$t = $(this), _$a = _$t.index(), s = _$t.offset().left - $(n).scrollLeft();
                        0 >= s && _$t.hasClass(i + "active-slide") ? n.flexAnimate(n.getTarget("prev"), !0) : $(n.vars.asNavFor).data("flexslider").animating || _$t.hasClass(i + "active-slide") || (n.direction = n.currentItem < _$a ? "next" : "prev", n.flexAnimate(_$a, n.vars.pauseOnAction, !1, !0, !0));
                    });
                }
            },
            controlNav: {
                setup: function setup() {
                    n.manualControls ? f.controlNav.setupManual() : f.controlNav.setupPaging();
                },
                setupPaging: function setupPaging() {
                    var e = "thumbnails" === n.vars.controlNav ? "control-thumbs" : "control-paging", _$t = 1, _$a, s;
                    if (n.controlNavScaffold = $('<ol class="' + i + "control-nav " + i + e + '"></ol>'), n.pagingCount > 1) for(var r = 0; r < n.pagingCount; r++){
                        s = n.slides.eq(r), void 0 === s.attr("data-thumb-alt") && s.attr("data-thumb-alt", "");
                        var c = "" !== s.attr("data-thumb-alt") ? c = ' alt="' + s.attr("data-thumb-alt") + '"' : "";
                        if (_$a = "thumbnails" === n.vars.controlNav ? '<img src="' + s.attr("data-thumb") + '"' + c + "/>" : '<a href="#">' + _$t + "</a>", "thumbnails" === n.vars.controlNav && !0 === n.vars.thumbCaptions) {
                            var d = s.attr("data-thumbcaption");
                            "" !== d && void 0 !== d && (_$a += '<span class="' + i + 'caption">' + d + "</span>");
                        }
                        n.controlNavScaffold.append("<li>" + _$a + "</li>"), _$t++;
                    }
                    n.controlsContainer ? $(n.controlsContainer).append(n.controlNavScaffold) : n.append(n.controlNavScaffold), f.controlNav.set(), f.controlNav.active(), n.controlNavScaffold.delegate("a, img", o, function(e) {
                        if (e.preventDefault(), "" === l || l === e.type) {
                            var _$t = $(this), _$a = n.controlNav.index(_$t);
                            _$t.hasClass(i + "active") || (n.direction = _$a > n.currentSlide ? "next" : "prev", n.flexAnimate(_$a, n.vars.pauseOnAction));
                        }
                        "" === l && (l = e.type), f.setToClearWatchedEvent();
                    });
                },
                setupManual: function setupManual() {
                    n.controlNav = n.manualControls, f.controlNav.active(), n.controlNav.bind(o, function(e) {
                        if (e.preventDefault(), "" === l || l === e.type) {
                            var _$t = $(this), _$a = n.controlNav.index(_$t);
                            _$t.hasClass(i + "active") || (_$a > n.currentSlide ? n.direction = "next" : n.direction = "prev", n.flexAnimate(_$a, n.vars.pauseOnAction));
                        }
                        "" === l && (l = e.type), f.setToClearWatchedEvent();
                    });
                },
                set: function set() {
                    var e = "thumbnails" === n.vars.controlNav ? "img" : "a";
                    n.controlNav = $("." + i + "control-nav li " + e, n.controlsContainer ? n.controlsContainer : n);
                },
                active: function active() {
                    n.controlNav.removeClass(i + "active").eq(n.animatingTo).addClass(i + "active");
                },
                update: function update(e, t) {
                    n.pagingCount > 1 && "add" === e ? n.controlNavScaffold.append($('<li><a href="#">' + n.count + "</a></li>")) : 1 === n.pagingCount ? n.controlNavScaffold.find("li").remove() : n.controlNav.eq(t).closest("li").remove(), f.controlNav.set(), n.pagingCount > 1 && n.pagingCount !== n.controlNav.length ? n.update(t, e) : f.controlNav.active();
                }
            },
            directionNav: {
                setup: function setup() {
                    var e = $('<ul class="' + i + 'direction-nav"><li class="' + i + 'nav-prev"><a class="' + i + 'prev" href="#">' + n.vars.prevText + '</a></li><li class="' + i + 'nav-next"><a class="' + i + 'next" href="#">' + n.vars.nextText + "</a></li></ul>");
                    n.customDirectionNav ? n.directionNav = n.customDirectionNav : n.controlsContainer ? ($(n.controlsContainer).append(e), n.directionNav = $("." + i + "direction-nav li a", n.controlsContainer)) : (n.append(e), n.directionNav = $("." + i + "direction-nav li a", n)), f.directionNav.update(), n.directionNav.bind(o, function(e) {
                        e.preventDefault();
                        var _$t;
                        ("" === l || l === e.type) && (_$t = $(this).hasClass(i + "next") ? n.getTarget("next") : n.getTarget("prev"), n.flexAnimate(_$t, n.vars.pauseOnAction)), "" === l && (l = e.type), f.setToClearWatchedEvent();
                    });
                },
                update: function update() {
                    var e = i + "disabled";
                    1 === n.pagingCount ? n.directionNav.addClass(e).attr("tabindex", "-1") : n.vars.animationLoop ? n.directionNav.removeClass(e).removeAttr("tabindex") : 0 === n.animatingTo ? n.directionNav.removeClass(e).filter("." + i + "prev").addClass(e).attr("tabindex", "-1") : n.animatingTo === n.last ? n.directionNav.removeClass(e).filter("." + i + "next").addClass(e).attr("tabindex", "-1") : n.directionNav.removeClass(e).removeAttr("tabindex");
                }
            },
            pausePlay: {
                setup: function setup() {
                    var e = $('<div class="' + i + 'pauseplay"><a href="#"></a></div>');
                    n.controlsContainer ? (n.controlsContainer.append(e), n.pausePlay = $("." + i + "pauseplay a", n.controlsContainer)) : (n.append(e), n.pausePlay = $("." + i + "pauseplay a", n)), f.pausePlay.update(n.vars.slideshow ? i + "pause" : i + "play"), n.pausePlay.bind(o, function(e) {
                        e.preventDefault(), ("" === l || l === e.type) && ($(this).hasClass(i + "pause") ? (n.manualPause = !0, n.manualPlay = !1, n.pause()) : (n.manualPause = !1, n.manualPlay = !0, n.play())), "" === l && (l = e.type), f.setToClearWatchedEvent();
                    });
                },
                update: function update(e) {
                    "play" === e ? n.pausePlay.removeClass(i + "pause").addClass(i + "play").html(n.vars.playText) : n.pausePlay.removeClass(i + "play").addClass(i + "pause").html(n.vars.pauseText);
                }
            },
            touch: function touch() {
                function e(e) {
                    e.stopPropagation(), n.animating ? e.preventDefault() : (n.pause(), t._gesture.addPointer(e.pointerId), T = 0, c = d ? n.h : n.w, f = Number(new Date), l = v && u && n.animatingTo === n.last ? 0 : v && u ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo : v && n.currentSlide === n.last ? n.limit : v ? (n.itemW + n.vars.itemMargin) * n.move * n.currentSlide : u ? (n.last - n.currentSlide + n.cloneOffset) * c : (n.currentSlide + n.cloneOffset) * c);
                }
                function a(e) {
                    e.stopPropagation();
                    var _$a = e.target._slider;
                    if (_$a) {
                        var n = -e.translationX, _$i = -e.translationY;
                        return T += d ? _$i : n, m = T, y = d ? Math.abs(T) < Math.abs(-n) : Math.abs(T) < Math.abs(-_$i), e.detail === e.MSGESTURE_FLAG_INERTIA ? void setImmediate(function() {
                            t._gesture.stop();
                        }) : void ((!y || Number(new Date) - f > 500) && (e.preventDefault(), !p && _$a.transitions && (_$a.vars.animationLoop || (m = T / (0 === _$a.currentSlide && 0 > T || _$a.currentSlide === _$a.last && T > 0 ? Math.abs(T) / c + 2 : 1)), _$a.setProps(l + m, "setTouch"))));
                    }
                }
                function i(e) {
                    e.stopPropagation();
                    var _$t = e.target._slider;
                    if (_$t) {
                        if (_$t.animatingTo === _$t.currentSlide && !y && null !== m) {
                            var _$a = u ? -m : m, n = _$a > 0 ? _$t.getTarget("next") : _$t.getTarget("prev");
                            _$t.canAdvance(n) && (Number(new Date) - f < 550 && Math.abs(_$a) > 50 || Math.abs(_$a) > c / 2) ? _$t.flexAnimate(n, _$t.vars.pauseOnAction) : p || _$t.flexAnimate(_$t.currentSlide, _$t.vars.pauseOnAction, !0);
                        }
                        r = null, o = null, m = null, l = null, T = 0;
                    }
                }
                var r, o, l, c, m, f, g, h, S, y = !1, x = 0, b = 0, T = 0;
                s ? (t.style.msTouchAction = "none", t._gesture = new MSGesture, t._gesture.target = t, t.addEventListener("MSPointerDown", e, !1), t._slider = n, t.addEventListener("MSGestureChange", a, !1), t.addEventListener("MSGestureEnd", i, !1)) : (g = function g(e) {
                    n.animating ? e.preventDefault() : (window.navigator.msPointerEnabled || 1 === e.touches.length) && (n.pause(), c = d ? n.h : n.w, f = Number(new Date), x = e.touches[0].pageX, b = e.touches[0].pageY, l = v && u && n.animatingTo === n.last ? 0 : v && u ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo : v && n.currentSlide === n.last ? n.limit : v ? (n.itemW + n.vars.itemMargin) * n.move * n.currentSlide : u ? (n.last - n.currentSlide + n.cloneOffset) * c : (n.currentSlide + n.cloneOffset) * c, r = d ? b : x, o = d ? x : b, t.addEventListener("touchmove", h, !1), t.addEventListener("touchend", S, !1));
                }, h = function h(e) {
                    x = e.touches[0].pageX, b = e.touches[0].pageY, m = d ? r - b : r - x, y = d ? Math.abs(m) < Math.abs(x - o) : Math.abs(m) < Math.abs(b - o);
                    var _$t = 500;
                    (!y || Number(new Date) - f > _$t) && (e.preventDefault(), !p && n.transitions && (n.vars.animationLoop || (m /= 0 === n.currentSlide && 0 > m || n.currentSlide === n.last && m > 0 ? Math.abs(m) / c + 2 : 1), n.setProps(l + m, "setTouch")));
                }, S = function(e) {
                    if (t.removeEventListener("touchmove", h, !1), n.animatingTo === n.currentSlide && !y && null !== m) {
                        var _$a = u ? -m : m, _$i = _$a > 0 ? n.getTarget("next") : n.getTarget("prev");
                        n.canAdvance(_$i) && (Number(new Date) - f < 550 && Math.abs(_$a) > 50 || Math.abs(_$a) > c / 2) ? n.flexAnimate(_$i, n.vars.pauseOnAction) : p || n.flexAnimate(n.currentSlide, n.vars.pauseOnAction, !0);
                    }
                    t.removeEventListener("touchend", S, !1), r = null, o = null, m = null, l = null;
                }, t.addEventListener("touchstart", g, !1));
            },
            resize: function resize() {
                !n.animating && n.is(":visible") && (v || n.doMath(), p ? f.smoothHeight() : v ? (n.slides.width(n.computedW), n.update(n.pagingCount), n.setProps()) : d ? (n.viewport.height(n.h), n.setProps(n.h, "setTotal")) : (n.vars.smoothHeight && f.smoothHeight(), n.newSlides.width(n.computedW), n.setProps(n.computedW, "setTotal")));
            },
            smoothHeight: function smoothHeight(e) {
                if (!d || p) {
                    var _$t = p ? n : n.viewport;
                    e ? _$t.animate({
                        height: n.slides.eq(n.animatingTo).innerHeight()
                    }, e) : _$t.innerHeight(n.slides.eq(n.animatingTo).innerHeight());
                }
            },
            sync: function sync(e) {
                var _$t = $(n.vars.sync).data("flexslider"), _$a = n.animatingTo;
                switch(e){
                    case "animate":
                        _$t.flexAnimate(_$a, n.vars.pauseOnAction, !1, !0);
                        break;
                    case "play":
                        _$t.playing || _$t.asNav || _$t.play();
                        break;
                    case "pause":
                        _$t.pause();
                }
            },
            uniqueID: function uniqueID(e) {
                return e.filter("[id]").add(e.find("[id]")).each(function() {
                    var _$e = $(this);
                    _$e.attr("id", _$e.attr("id") + "_clone");
                }), e;
            },
            pauseInvisible: {
                visProp: null,
                init: function init() {
                    var e = f.pauseInvisible.getHiddenProp();
                    if (e) {
                        var _$t = e.replace(/[H|h]idden/, "") + "visibilitychange";
                        document.addEventListener(_$t, function() {
                            f.pauseInvisible.isHidden() ? n.startTimeout ? clearTimeout(n.startTimeout) : n.pause() : n.started ? n.play() : n.vars.initDelay > 0 ? setTimeout(n.play, n.vars.initDelay) : n.play();
                        });
                    }
                },
                isHidden: function isHidden() {
                    var e = f.pauseInvisible.getHiddenProp();
                    return e ? document[e] : !1;
                },
                getHiddenProp: function getHiddenProp() {
                    var e = [
                        "webkit",
                        "moz",
                        "ms",
                        "o"
                    ];
                    if ("hidden" in document) return "hidden";
                    for(var _$t = 0; _$t < e.length; _$t++)if (e[_$t] + "Hidden" in document) return e[_$t] + "Hidden";
                    return null;
                }
            },
            setToClearWatchedEvent: function setToClearWatchedEvent() {
                clearTimeout(c), c = setTimeout(function() {
                    l = "";
                }, 3e3);
            }
        }, n.flexAnimate = function(e, t, a, s, o) {
            if (n.vars.animationLoop || e === n.currentSlide || (n.direction = e > n.currentSlide ? "next" : "prev"), m && 1 === n.pagingCount && (n.direction = n.currentItem < e ? "next" : "prev"), !n.animating && (n.canAdvance(e, o) || a) && n.is(":visible")) {
                if (m && s) {
                    var l = $(n.vars.asNavFor).data("flexslider");
                    if (n.atEnd = 0 === e || e === n.count - 1, l.flexAnimate(e, !0, !1, !0, o), n.direction = n.currentItem < e ? "next" : "prev", l.direction = n.direction, Math.ceil((e + 1) / n.visible) - 1 === n.currentSlide || 0 === e) return n.currentItem = e, n.slides.removeClass(i + "active-slide").eq(e).addClass(i + "active-slide"), !1;
                    n.currentItem = e, n.slides.removeClass(i + "active-slide").eq(e).addClass(i + "active-slide"), e = Math.floor(e / n.visible);
                }
                if (n.animating = !0, n.animatingTo = e, t && n.pause(), n.vars.before(n), n.syncExists && !o && f.sync("animate"), n.vars.controlNav && f.controlNav.active(), v || n.slides.removeClass(i + "active-slide").eq(e).addClass(i + "active-slide"), n.atEnd = 0 === e || e === n.last, n.vars.directionNav && f.directionNav.update(), e === n.last && (n.vars.end(n), n.vars.animationLoop || n.pause()), p) r ? (n.slides.eq(n.currentSlide).css({
                    opacity: 0,
                    zIndex: 1
                }), n.slides.eq(e).css({
                    opacity: 1,
                    zIndex: 2
                }), n.wrapup(c)) : (n.slides.eq(n.currentSlide).css({
                    zIndex: 1
                }).animate({
                    opacity: 0
                }, n.vars.animationSpeed, n.vars.easing), n.slides.eq(e).css({
                    zIndex: 2
                }).animate({
                    opacity: 1
                }, n.vars.animationSpeed, n.vars.easing, n.wrapup));
                else {
                    var c = d ? n.slides.filter(":first").height() : n.computedW, g, h, S;
                    v ? (g = n.vars.itemMargin, S = (n.itemW + g) * n.move * n.animatingTo, h = S > n.limit && 1 !== n.visible ? n.limit : S) : h = 0 === n.currentSlide && e === n.count - 1 && n.vars.animationLoop && "next" !== n.direction ? u ? (n.count + n.cloneOffset) * c : 0 : n.currentSlide === n.last && 0 === e && n.vars.animationLoop && "prev" !== n.direction ? u ? 0 : (n.count + 1) * c : u ? (n.count - 1 - e + n.cloneOffset) * c : (e + n.cloneOffset) * c, n.setProps(h, "", n.vars.animationSpeed), n.transitions ? (n.vars.animationLoop && n.atEnd || (n.animating = !1, n.currentSlide = n.animatingTo), n.container.unbind("webkitTransitionEnd transitionend"), n.container.bind("webkitTransitionEnd transitionend", function() {
                        clearTimeout(n.ensureAnimationEnd), n.wrapup(c);
                    }), clearTimeout(n.ensureAnimationEnd), n.ensureAnimationEnd = setTimeout(function() {
                        n.wrapup(c);
                    }, n.vars.animationSpeed + 100)) : n.container.animate(n.args, n.vars.animationSpeed, n.vars.easing, function() {
                        n.wrapup(c);
                    });
                }
                n.vars.smoothHeight && f.smoothHeight(n.vars.animationSpeed);
            }
        }, n.wrapup = function(e) {
            p || v || (0 === n.currentSlide && n.animatingTo === n.last && n.vars.animationLoop ? n.setProps(e, "jumpEnd") : n.currentSlide === n.last && 0 === n.animatingTo && n.vars.animationLoop && n.setProps(e, "jumpStart")), n.animating = !1, n.currentSlide = n.animatingTo, n.vars.after(n);
        }, n.animateSlides = function() {
            !n.animating && e && n.flexAnimate(n.getTarget("next"));
        }, n.pause = function() {
            clearInterval(n.animatedSlides), n.animatedSlides = null, n.playing = !1, n.vars.pausePlay && f.pausePlay.update("play"), n.syncExists && f.sync("pause");
        }, n.play = function() {
            n.playing && clearInterval(n.animatedSlides), n.animatedSlides = n.animatedSlides || setInterval(n.animateSlides, n.vars.slideshowSpeed), n.started = n.playing = !0, n.vars.pausePlay && f.pausePlay.update("pause"), n.syncExists && f.sync("play");
        }, n.stop = function() {
            n.pause(), n.stopped = !0;
        }, n.canAdvance = function(e, t) {
            var _$a = m ? n.pagingCount - 1 : n.last;
            return t ? !0 : m && n.currentItem === n.count - 1 && 0 === e && "prev" === n.direction ? !0 : m && 0 === n.currentItem && e === n.pagingCount - 1 && "next" !== n.direction ? !1 : e !== n.currentSlide || m ? n.vars.animationLoop ? !0 : n.atEnd && 0 === n.currentSlide && e === _$a && "next" !== n.direction ? !1 : n.atEnd && n.currentSlide === _$a && 0 === e && "next" === n.direction ? !1 : !0 : !1;
        }, n.getTarget = function(e) {
            return n.direction = e, "next" === e ? n.currentSlide === n.last ? 0 : n.currentSlide + 1 : 0 === n.currentSlide ? n.last : n.currentSlide - 1;
        }, n.setProps = function(e, t, a) {
            var i = function() {
                var _$a = e ? e : (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo, i = function() {
                    if (v) return "setTouch" === t ? e : u && n.animatingTo === n.last ? 0 : u ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo : n.animatingTo === n.last ? n.limit : _$a;
                    switch(t){
                        case "setTotal":
                            return u ? (n.count - 1 - n.currentSlide + n.cloneOffset) * e : (n.currentSlide + n.cloneOffset) * e;
                        case "setTouch":
                            return u ? e : e;
                        case "jumpEnd":
                            return u ? e : n.count * e;
                        case "jumpStart":
                            return u ? n.count * e : e;
                        default:
                            return e;
                    }
                }();
                return -1 * i + "px";
            }();
            n.transitions && (i = d ? "translate3d(0," + i + ",0)" : "translate3d(" + i + ",0,0)", a = void 0 !== a ? a / 1e3 + "s" : "0s", n.container.css("-" + n.pfx + "-transition-duration", a), n.container.css("transition-duration", a)), n.args[n.prop] = i, (n.transitions || void 0 === a) && n.container.css(n.args), n.container.css("transform", i);
        }, n.setup = function(e) {
            if (p) n.slides.css({
                width: "100%",
                "float": "left",
                marginRight: "-100%",
                position: "relative"
            }), "init" === e && (r ? n.slides.css({
                opacity: 0,
                display: "block",
                webkitTransition: "opacity " + n.vars.animationSpeed / 1e3 + "s ease",
                zIndex: 1
            }).eq(n.currentSlide).css({
                opacity: 1,
                zIndex: 2
            }) : 0 == n.vars.fadeFirstSlide ? n.slides.css({
                opacity: 0,
                display: "block",
                zIndex: 1
            }).eq(n.currentSlide).css({
                zIndex: 2
            }).css({
                opacity: 1
            }) : n.slides.css({
                opacity: 0,
                display: "block",
                zIndex: 1
            }).eq(n.currentSlide).css({
                zIndex: 2
            }).animate({
                opacity: 1
            }, n.vars.animationSpeed, n.vars.easing)), n.vars.smoothHeight && f.smoothHeight();
            else {
                var _$t, _$a;
                "init" === e && (n.viewport = $('<div class="' + i + 'viewport"></div>').css({
                    overflow: "hidden",
                    position: "relative"
                }).appendTo(n).append(n.container), n.cloneCount = 0, n.cloneOffset = 0, u && (_$a = $.makeArray(n.slides).reverse(), n.slides = $(_$a), n.container.empty().append(n.slides))), n.vars.animationLoop && !v && (n.cloneCount = 2, n.cloneOffset = 1, "init" !== e && n.container.find(".clone").remove(), n.container.append(f.uniqueID(n.slides.first().clone().addClass("clone")).attr("aria-hidden", "true")).prepend(f.uniqueID(n.slides.last().clone().addClass("clone")).attr("aria-hidden", "true"))), n.newSlides = $(n.vars.selector, n), _$t = u ? n.count - 1 - n.currentSlide + n.cloneOffset : n.currentSlide + n.cloneOffset, d && !v ? (n.container.height(200 * (n.count + n.cloneCount) + "%").css("position", "absolute").width("100%"), setTimeout(function() {
                    n.newSlides.css({
                        display: "block"
                    }), n.doMath(), n.viewport.height(n.h), n.setProps(_$t * n.h, "init");
                }, "init" === e ? 100 : 0)) : (n.container.width(200 * (n.count + n.cloneCount) + "%"), n.setProps(_$t * n.computedW, "init"), setTimeout(function() {
                    n.doMath(), n.newSlides.css({
                        width: n.computedW,
                        marginRight: n.computedM,
                        "float": "left",
                        display: "block"
                    }), n.vars.smoothHeight && f.smoothHeight();
                }, "init" === e ? 100 : 0));
            }
            v || n.slides.removeClass(i + "active-slide").eq(n.currentSlide).addClass(i + "active-slide"), n.vars.init(n);
        }, n.doMath = function() {
            var e = n.slides.first(), _$t = n.vars.itemMargin, _$a = n.vars.minItems, i = n.vars.maxItems;
            n.w = void 0 === n.viewport ? n.width() : n.viewport.width(), n.h = e.height(), n.boxPadding = e.outerWidth() - e.width(), v ? (n.itemT = n.vars.itemWidth + _$t, n.itemM = _$t, n.minW = _$a ? _$a * n.itemT : n.w, n.maxW = i ? i * n.itemT - _$t : n.w, n.itemW = n.minW > n.w ? (n.w - _$t * (_$a - 1)) / _$a : n.maxW < n.w ? (n.w - _$t * (i - 1)) / i : n.vars.itemWidth > n.w ? n.w : n.vars.itemWidth, n.visible = Math.floor(n.w / n.itemW), n.move = n.vars.move > 0 && n.vars.move < n.visible ? n.vars.move : n.visible, n.pagingCount = Math.ceil((n.count - n.visible) / n.move + 1), n.last = n.pagingCount - 1, n.limit = 1 === n.pagingCount ? 0 : n.vars.itemWidth > n.w ? n.itemW * (n.count - 1) + _$t * (n.count - 1) : (n.itemW + _$t) * n.count - n.w - _$t) : (n.itemW = n.w, n.itemM = _$t, n.pagingCount = n.count, n.last = n.count - 1), n.computedW = n.itemW - n.boxPadding, n.computedM = n.itemM;
        }, n.update = function(e, t) {
            n.doMath(), v || (e < n.currentSlide ? n.currentSlide += 1 : e <= n.currentSlide && 0 !== e && (n.currentSlide -= 1), n.animatingTo = n.currentSlide), n.vars.controlNav && !n.manualControls && ("add" === t && !v || n.pagingCount > n.controlNav.length ? f.controlNav.update("add") : ("remove" === t && !v || n.pagingCount < n.controlNav.length) && (v && n.currentSlide > n.last && (n.currentSlide -= 1, n.animatingTo -= 1), f.controlNav.update("remove", n.last))), n.vars.directionNav && f.directionNav.update();
        }, n.addSlide = function(e, t) {
            var _$a = $(e);
            n.count += 1, n.last = n.count - 1, d && u ? void 0 !== t ? n.slides.eq(n.count - t).after(_$a) : n.container.prepend(_$a) : void 0 !== t ? n.slides.eq(t).before(_$a) : n.container.append(_$a), n.update(t, "add"), n.slides = $(n.vars.selector + ":not(.clone)", n), n.setup(), n.vars.added(n);
        }, n.removeSlide = function(e) {
            var _$t = isNaN(e) ? n.slides.index($(e)) : e;
            n.count -= 1, n.last = n.count - 1, isNaN(e) ? $(e, n.slides).remove() : d && u ? n.slides.eq(n.last).remove() : n.slides.eq(e).remove(), n.doMath(), n.update(_$t, "remove"), n.slides = $(n.vars.selector + ":not(.clone)", n), n.setup(), n.vars.removed(n);
        }, f.init();
    }, $(window).blur(function(t) {
        e = !1;
    }).focus(function(t) {
        e = !0;
    }), $.flexslider.defaults = {
        namespace: "flex-",
        selector: ".slides > li",
        animation: "fade",
        easing: "swing",
        direction: "horizontal",
        reverse: !1,
        animationLoop: !0,
        smoothHeight: !1,
        startAt: 0,
        slideshow: !0,
        slideshowSpeed: 7e3,
        animationSpeed: 600,
        initDelay: 0,
        randomize: !1,
        fadeFirstSlide: !0,
        thumbCaptions: !1,
        pauseOnAction: !0,
        pauseOnHover: !1,
        pauseInvisible: !0,
        useCSS: !0,
        touch: !0,
        video: !1,
        controlNav: !0,
        directionNav: !0,
        prevText: "Previous",
        nextText: "Next",
        keyboard: !0,
        multipleKeyboard: !1,
        mousewheel: !1,
        pausePlay: !1,
        pauseText: "Pause",
        playText: "Play",
        controlsContainer: "",
        manualControls: "",
        customDirectionNav: "",
        sync: "",
        asNavFor: "",
        itemWidth: 0,
        itemMargin: 0,
        minItems: 1,
        maxItems: 0,
        move: 0,
        allowOneSlide: !0,
        start: function start() {},
        before: function before() {},
        after: function after() {},
        end: function end() {},
        added: function added() {},
        removed: function removed() {},
        init: function init() {}
    }, $.fn.flexslider = function(e) {
        if (void 0 === e && (e = {}), "object" == typeof e) return this.each(function() {
            var t = $(this), a = e.selector ? e.selector : ".slides > li", n = t.find(a);
            1 === n.length && e.allowOneSlide === !1 || 0 === n.length ? (n.fadeIn(400), e.start && e.start(t)) : void 0 === t.data("flexslider") && new $.flexslider(this, e);
        });
        var t = $(this).data("flexslider");
        switch(e){
            case "play":
                t.play();
                break;
            case "pause":
                t.pause();
                break;
            case "stop":
                t.stop();
                break;
            case "next":
                t.flexAnimate(t.getTarget("next"), !0);
                break;
            case "prev":
            case "previous":
                t.flexAnimate(t.getTarget("prev"), !0);
                break;
            default:
                "number" == typeof e && t.flexAnimate(e, !0);
        }
    };
}(jQuery);


(function($, window1, document1, undefined) {
    var pluginName = "accordion", defaults = {
        transitionSpeed: 300,
        transitionEasing: "ease",
        controlElement: "[data-control]",
        contentElement: "[data-content]",
        groupElement: "[data-accordion-group]",
        singleOpen: true
    };
    function Accordion(element, options) {
        this.element = element;
        this.options = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }
    Accordion.prototype.init = function() {
        var self = this, opts = self.options;
        var $accordion = $(self.element), $controls = $accordion.find("> " + opts.controlElement), $content = $accordion.find("> " + opts.contentElement);
        var accordionParentsQty = $accordion.parents("[data-accordion]").length, accordionHasParent = accordionParentsQty > 0;
        var closedCSS = {
            "max-height": 0,
            "overflow": "hidden"
        };
        var CSStransitions = supportsTransitions();
        function debounce(func, threshold, execAsap) {
            var timeout;
            return function debounced() {
                var obj = this, args = arguments;
                function delayed() {
                    if (!execAsap) func.apply(obj, args);
                    timeout = null;
                }
                if (timeout) clearTimeout(timeout);
                else if (execAsap) func.apply(obj, args);
                timeout = setTimeout(delayed, threshold || 100);
            };
        }
        function supportsTransitions() {
            var b = document1.body || document1.documentElement, s = b.style, p = "transition";
            if (typeof s[p] == "string") return true;
            var v = [
                "Moz",
                "webkit",
                "Webkit",
                "Khtml",
                "O",
                "ms"
            ];
            p = "Transition";
            for(var i = 0; i < v.length; i++){
                if (typeof s[v[i] + p] == "string") return true;
            }
            return false;
        }
        function requestAnimFrame(cb) {
            if (window1.requestAnimationFrame || window1.webkitRequestAnimationFrame || window1.mozRequestAnimationFrame) return requestAnimationFrame(cb) || webkitRequestAnimationFrame(cb) || mozRequestAnimationFrame(cb);
            else return setTimeout(cb, 1000 / 60);
        }
        function toggleTransition($el, remove) {
            if (!remove) $content.css({
                "-webkit-transition": "max-height " + opts.transitionSpeed + "ms " + opts.transitionEasing,
                "transition": "max-height " + opts.transitionSpeed + "ms " + opts.transitionEasing
            });
            else $content.css({
                "-webkit-transition": "",
                "transition": ""
            });
        }
        function calculateHeight($el) {
            var height = 0;
            $el.children().each(function() {
                height = height + $(this).outerHeight(true);
            });
            $el.data("oHeight", height);
        }
        function updateParentHeight($parentAccordion, $currentAccordion, qty, operation) {
            var $content = $parentAccordion.filter(".open").find("> [data-content]"), $childs = $content.find("[data-accordion].open > [data-content]"), $matched;
            if (!opts.singleOpen) $childs = $childs.not($currentAccordion.siblings("[data-accordion].open").find("> [data-content]"));
            $matched = $content.add($childs);
            if ($parentAccordion.hasClass("open")) $matched.each(function() {
                var currentHeight = $(this).data("oHeight");
                switch(operation){
                    case "+":
                        $(this).data("oHeight", currentHeight + qty);
                        break;
                    case "-":
                        $(this).data("oHeight", currentHeight - qty);
                        break;
                    default:
                        throw "updateParentHeight method needs an operation";
                }
                $(this).css("max-height", $(this).data("oHeight"));
            });
        }
        function refreshHeight($accordion) {
            if ($accordion.hasClass("open")) {
                var $content = $accordion.find("> [data-content]"), $childs = $content.find("[data-accordion].open > [data-content]"), $matched = $content.add($childs);
                calculateHeight($matched);
                $matched.css("max-height", $matched.data("oHeight"));
            }
        }
        function closeAccordion($accordion, $content) {
            $accordion.trigger("accordion.close");
            if (CSStransitions) {
                if (accordionHasParent) {
                    var $parentAccordions = $accordion.parents("[data-accordion]");
                    updateParentHeight($parentAccordions, $accordion, $content.data("oHeight"), "-");
                }
                $content.css(closedCSS);
                $accordion.removeClass("open");
            } else {
                $content.css("max-height", $content.data("oHeight"));
                $content.animate(closedCSS, opts.transitionSpeed);
                $accordion.removeClass("open");
            }
        }
        function openAccordion($accordion, $content) {
            $accordion.trigger("accordion.open");
            if (CSStransitions) {
                toggleTransition($content);
                if (accordionHasParent) {
                    var $parentAccordions = $accordion.parents("[data-accordion]");
                    updateParentHeight($parentAccordions, $accordion, $content.data("oHeight"), "+");
                }
                requestAnimFrame(function() {
                    $content.css("max-height", $content.data("oHeight"));
                });
                $accordion.addClass("open");
            } else {
                $content.animate({
                    "max-height": $content.data("oHeight")
                }, opts.transitionSpeed, function() {
                    $content.css({
                        "max-height": "none"
                    });
                });
                $accordion.addClass("open");
            }
        }
        function closeSiblingAccordions($accordion) {
            var $accordionGroup = $accordion.closest(opts.groupElement);
            var $siblings = $accordion.siblings("[data-accordion]").filter(".open"), $siblingsChildren = $siblings.find("[data-accordion]").filter(".open");
            var $otherAccordions = $siblings.add($siblingsChildren);
            $otherAccordions.each(function() {
                var _$$accordion = $(this), $content = _$$accordion.find(opts.contentElement);
                closeAccordion(_$$accordion, $content);
            });
            $otherAccordions.removeClass("open");
        }
        function toggleAccordion() {
            var isAccordionGroup = opts.singleOpen ? $accordion.parents(opts.groupElement).length > 0 : false;
            calculateHeight($content);
            if (isAccordionGroup) closeSiblingAccordions($accordion);
            if ($accordion.hasClass("open")) closeAccordion($accordion, $content);
            else openAccordion($accordion, $content);
        }
        function addEventListeners() {
            $controls.on("click", toggleAccordion);
            $controls.on("accordion.toggle", function() {
                if (opts.singleOpen && $controls.length > 1) return false;
                toggleAccordion();
            });
            $(window1).on("resize", debounce(function() {
                refreshHeight($accordion);
            }));
        }
        function setup() {
            $content.each(function() {
                var $curr = $(this);
                if ($curr.css("max-height") != 0) {
                    if (!$curr.closest("[data-accordion]").hasClass("open")) $curr.css({
                        "max-height": 0,
                        "overflow": "hidden"
                    });
                    else {
                        toggleTransition($curr);
                        calculateHeight($curr);
                        $curr.css("max-height", $curr.data("oHeight"));
                    }
                }
            });
            if (!$accordion.attr("data-accordion")) {
                $accordion.attr("data-accordion", "");
                $accordion.find(opts.controlElement).attr("data-control", "");
                $accordion.find(opts.contentElement).attr("data-content", "");
            }
        }
        setup();
        addEventListeners();
    };
    $.fn[pluginName] = function(options) {
        return this.each(function() {
            if (!$.data(this, "plugin_" + pluginName)) $.data(this, "plugin_" + pluginName, new Accordion(this, options));
        });
    };
})(jQuery, window, document);


/*
 * CSS3 Animate it
 * Copyright (c) 2014 Jack McCourt
 * https://github.com/kriegar/css3-animate-it
 * Version: 0.1.0
 * 
 * I utilise the jQuery.appear plugin within this javascript file so here is a link to that too
 * https://github.com/morr/jquery.appear
 *
 * I also utilise the jQuery.doTimeout plugin for the data-sequence functionality so here is a link back to them.
 * http://benalman.com/projects/jquery-dotimeout-plugin/
 */ (function($1) {
    var selectors = [];
    var check_binded = false;
    var check_lock = false;
    var defaults = {
        interval: 250,
        force_process: false
    };
    var $window = $1(window);
    var $prior_appeared;
    function process() {
        check_lock = false;
        for(var index = 0; index < selectors.length; index++){
            var $appeared = $1(selectors[index]).filter(function() {
                return $1(this).is(":appeared");
            });
            $appeared.trigger("appear", [
                $appeared
            ]);
            if ($prior_appeared) {
                var $disappeared = $prior_appeared.not($appeared);
                $disappeared.trigger("disappear", [
                    $disappeared
                ]);
            }
            $prior_appeared = $appeared;
        }
    }
    // "appeared" custom filter
    $1.expr[":"]["appeared"] = function(element) {
        var $element = $1(element);
        if (!$element.is(":visible")) return false;
        var window_left = $window.scrollLeft();
        var window_top = $window.scrollTop();
        var offset = $element.offset();
        var left = offset.left;
        var top = offset.top;
        if (top + $element.height() >= window_top && top - ($element.data("appear-top-offset") || 0) <= window_top + $window.height() && left + $element.width() >= window_left && left - ($element.data("appear-left-offset") || 0) <= window_left + $window.width()) return true;
        else return false;
    };
    $1.fn.extend({
        // watching for element's appearance in browser viewport
        appear: function appear(options) {
            var opts = $1.extend({}, defaults, options || {});
            var selector = this.selector || this;
            if (!check_binded) {
                var on_check = function on_check() {
                    if (check_lock) return;
                    check_lock = true;
                    setTimeout(process, opts.interval);
                };
                $1(window).scroll(on_check).resize(on_check);
                check_binded = true;
            }
            if (opts.force_process) setTimeout(process, opts.interval);
            selectors.push(selector);
            return $1(selector);
        }
    });
    $1.extend({
        // force elements's appearance check
        force_appear: function force_appear() {
            if (check_binded) {
                process();
                return true;
            }
            return false;
        }
    });
})(jQuery);
/*!
   * jQuery doTimeout: Like setTimeout, but better! - v1.0 - 3/3/2010
   * http://benalman.com/projects/jquery-dotimeout-plugin/
   * 
   * Copyright (c) 2010 "Cowboy" Ben Alman
   * Dual licensed under the MIT and GPL licenses.
   * http://benalman.com/about/license/
   */ // Script: jQuery doTimeout: Like setTimeout, but better!
//
// *Version: 1.0, Last updated: 3/3/2010*
// 
// Project Home - http://benalman.com/projects/jquery-dotimeout-plugin/
// GitHub       - http://github.com/cowboy/jquery-dotimeout/
// Source       - http://github.com/cowboy/jquery-dotimeout/raw/master/jquery.ba-dotimeout.js
// (Minified)   - http://github.com/cowboy/jquery-dotimeout/raw/master/jquery.ba-dotimeout.min.js (1.0kb)
// 
// About: License
// 
// Copyright (c) 2010 "Cowboy" Ben Alman,
// Dual licensed under the MIT and GPL licenses.
// http://benalman.com/about/license/
// 
// About: Examples
// 
// These working examples, complete with fully commented code, illustrate a few
// ways in which this plugin can be used.
// 
// Debouncing      - http://benalman.com/code/projects/jquery-dotimeout/examples/debouncing/
// Delays, Polling - http://benalman.com/code/projects/jquery-dotimeout/examples/delay-poll/
// Hover Intent    - http://benalman.com/code/projects/jquery-dotimeout/examples/hoverintent/
// 
// About: Support and Testing
// 
// Information about what version or versions of jQuery this plugin has been
// tested with, what browsers it has been tested in, and where the unit tests
// reside (so you can test it yourself).
// 
// jQuery Versions - 1.3.2, 1.4.2
// Browsers Tested - Internet Explorer 6-8, Firefox 2-3.6, Safari 3-4, Chrome 4-5, Opera 9.6-10.1.
// Unit Tests      - http://benalman.com/code/projects/jquery-dotimeout/unit/
// 
// About: Release History
// 
// 1.0 - (3/3/2010) Callback can now be a string, in which case it will call
//       the appropriate $.method or $.fn.method, depending on where .doTimeout
//       was called. Callback must now return `true` (not just a truthy value)
//       to poll.
// 0.4 - (7/15/2009) Made the "id" argument optional, some other minor tweaks
// 0.3 - (6/25/2009) Initial release
(function($1) {
    "$:nomunge"; // Used by YUI compressor.
    var cache = {}, // Reused internal string.
    doTimeout = "doTimeout", // A convenient shortcut.
    aps = Array.prototype.slice;
    // Method: jQuery.doTimeout
    // 
    // Initialize, cancel, or force execution of a callback after a delay.
    // 
    // If delay and callback are specified, a doTimeout is initialized. The
    // callback will execute, asynchronously, after the delay. If an id is
    // specified, this doTimeout will override and cancel any existing doTimeout
    // with the same id. Any additional arguments will be passed into callback
    // when it is executed.
    // 
    // If the callback returns true, the doTimeout loop will execute again, after
    // the delay, creating a polling loop until the callback returns a non-true
    // value.
    // 
    // Note that if an id is not passed as the first argument, this doTimeout will
    // NOT be able to be manually canceled or forced. (for debouncing, be sure to
    // specify an id).
    // 
    // If id is specified, but delay and callback are not, the doTimeout will be
    // canceled without executing the callback. If force_mode is specified, the
    // callback will be executed, synchronously, but will only be allowed to
    // continue a polling loop if force_mode is true (provided the callback
    // returns true, of course). If force_mode is false, no polling loop will
    // continue, even if the callback returns true.
    // 
    // Usage:
    // 
    // > jQuery.doTimeout( [ id, ] delay, callback [, arg ... ] );
    // > jQuery.doTimeout( id [, force_mode ] );
    // 
    // Arguments:
    // 
    //  id - (String) An optional unique identifier for this doTimeout. If id is
    //    not specified, the doTimeout will NOT be able to be manually canceled or
    //    forced.
    //  delay - (Number) A zero-or-greater delay in milliseconds after which
    //    callback will be executed. 
    //  callback - (Function) A function to be executed after delay milliseconds.
    //  callback - (String) A jQuery method to be executed after delay
    //    milliseconds. This method will only poll if it explicitly returns
    //    true.
    //  force_mode - (Boolean) If true, execute that id's doTimeout callback
    //    immediately and synchronously, continuing any callback return-true
    //    polling loop. If false, execute the callback immediately and
    //    synchronously but do NOT continue a callback return-true polling loop.
    //    If omitted, cancel that id's doTimeout.
    // 
    // Returns:
    // 
    //  If force_mode is true, false or undefined and there is a
    //  yet-to-be-executed callback to cancel, true is returned, but if no
    //  callback remains to be executed, undefined is returned.
    $1[doTimeout] = function() {
        return p_doTimeout.apply(window, [
            0
        ].concat(aps.call(arguments)));
    };
    // Method: jQuery.fn.doTimeout
    // 
    // Initialize, cancel, or force execution of a callback after a delay.
    // Operates like <jQuery.doTimeout>, but the passed callback executes in the
    // context of the jQuery collection of elements, and the id is stored as data
    // on the first element in that collection.
    // 
    // If delay and callback are specified, a doTimeout is initialized. The
    // callback will execute, asynchronously, after the delay. If an id is
    // specified, this doTimeout will override and cancel any existing doTimeout
    // with the same id. Any additional arguments will be passed into callback
    // when it is executed.
    // 
    // If the callback returns true, the doTimeout loop will execute again, after
    // the delay, creating a polling loop until the callback returns a non-true
    // value.
    // 
    // Note that if an id is not passed as the first argument, this doTimeout will
    // NOT be able to be manually canceled or forced (for debouncing, be sure to
    // specify an id).
    // 
    // If id is specified, but delay and callback are not, the doTimeout will be
    // canceled without executing the callback. If force_mode is specified, the
    // callback will be executed, synchronously, but will only be allowed to
    // continue a polling loop if force_mode is true (provided the callback
    // returns true, of course). If force_mode is false, no polling loop will
    // continue, even if the callback returns true.
    // 
    // Usage:
    // 
    // > jQuery('selector').doTimeout( [ id, ] delay, callback [, arg ... ] );
    // > jQuery('selector').doTimeout( id [, force_mode ] );
    // 
    // Arguments:
    // 
    //  id - (String) An optional unique identifier for this doTimeout, stored as
    //    jQuery data on the element. If id is not specified, the doTimeout will
    //    NOT be able to be manually canceled or forced.
    //  delay - (Number) A zero-or-greater delay in milliseconds after which
    //    callback will be executed. 
    //  callback - (Function) A function to be executed after delay milliseconds.
    //  callback - (String) A jQuery.fn method to be executed after delay
    //    milliseconds. This method will only poll if it explicitly returns
    //    true (most jQuery.fn methods return a jQuery object, and not `true`,
    //    which allows them to be chained and prevents polling).
    //  force_mode - (Boolean) If true, execute that id's doTimeout callback
    //    immediately and synchronously, continuing any callback return-true
    //    polling loop. If false, execute the callback immediately and
    //    synchronously but do NOT continue a callback return-true polling loop.
    //    If omitted, cancel that id's doTimeout.
    // 
    // Returns:
    // 
    //  When creating a <jQuery.fn.doTimeout>, the initial jQuery collection of
    //  elements is returned. Otherwise, if force_mode is true, false or undefined
    //  and there is a yet-to-be-executed callback to cancel, true is returned,
    //  but if no callback remains to be executed, undefined is returned.
    $1.fn[doTimeout] = function() {
        var args = aps.call(arguments), result = p_doTimeout.apply(this, [
            doTimeout + args[0]
        ].concat(args));
        return typeof args[0] === "number" || typeof args[1] === "number" ? this : result;
    };
    function p_doTimeout(jquery_data_key) {
        var that = this, elem, data = {}, // Allows the plugin to call a string callback method.
        method_base = jquery_data_key ? $1.fn : $1, // Any additional arguments will be passed to the callback.
        args = arguments, slice_args = 4, id = args[1], delay1 = args[2], callback = args[3];
        if (typeof id !== "string") {
            slice_args--;
            id = jquery_data_key = 0;
            delay1 = args[1];
            callback = args[2];
        }
        // If id is passed, store a data reference either as .data on the first
        // element in a jQuery collection, or in the internal cache.
        if (jquery_data_key) {
            // Get id-object from the first element's data, otherwise initialize it to {}.
            elem = that.eq(0);
            elem.data(jquery_data_key, data = elem.data(jquery_data_key) || {});
        } else if (id) // Get id-object from the cache, otherwise initialize it to {}.
        data = cache[id] || (cache[id] = {});
        // Clear any existing timeout for this id.
        data.id && clearTimeout(data.id);
        delete data.id;
        // Clean up when necessary.
        function cleanup() {
            if (jquery_data_key) elem.removeData(jquery_data_key);
            else if (id) delete cache[id];
        }
        // Yes, there actually is a setTimeout call in here!
        function actually_setTimeout() {
            data.id = setTimeout(function() {
                data.fn();
            }, delay1);
        }
        if (callback) {
            // A callback (and delay) were specified. Store the callback reference for
            // possible later use, and then setTimeout.
            data.fn = function(no_polling_loop) {
                // If the callback value is a string, it is assumed to be the name of a
                // method on $ or $.fn depending on where doTimeout was executed.
                if (typeof callback === "string") callback = method_base[callback];
                callback.apply(that, aps.call(args, slice_args)) === true && !no_polling_loop ? actually_setTimeout() : cleanup();
            };
            // Set that timeout!
            actually_setTimeout();
        } else if (data.fn) {
            // No callback passed. If force_mode (delay) is true, execute the data.fn
            // callback immediately, continuing any callback return-true polling loop.
            // If force_mode is false, execute the data.fn callback immediately but do
            // NOT continue a callback return-true polling loop. If force_mode is
            // undefined, simply clean up. Since data.fn was still defined, whatever
            // was supposed to happen hadn't yet, so return true.
            delay1 === undefined ? cleanup() : data.fn(delay1 === false);
            return true;
        } else // Since no callback was passed, and data.fn isn't defined, it looks like
        // whatever was supposed to happen already did. Clean up and quit!
        cleanup();
    }
})(jQuery);
//CSS3 Animate-it
$(".animatedParent").appear();
$(".animatedClick").click(function() {
    var target = $(this).attr("data-target");
    if ($(this).attr("data-sequence") != undefined) {
        var firstId = $("." + target + ":first").attr("data-id");
        var lastId = $("." + target + ":last").attr("data-id");
        var number = firstId;
        //Add or remove the class
        if ($("." + target + "[data-id=" + number + "]").hasClass("go")) {
            $("." + target + "[data-id=" + number + "]").addClass("goAway");
            $("." + target + "[data-id=" + number + "]").removeClass("go");
        } else {
            $("." + target + "[data-id=" + number + "]").addClass("go");
            $("." + target + "[data-id=" + number + "]").removeClass("goAway");
        }
        number++;
        delay = Number($(this).attr("data-sequence"));
        $.doTimeout(delay, function() {
            console.log(lastId);
            //Add or remove the class
            if ($("." + target + "[data-id=" + number + "]").hasClass("go")) {
                $("." + target + "[data-id=" + number + "]").addClass("goAway");
                $("." + target + "[data-id=" + number + "]").removeClass("go");
            } else {
                $("." + target + "[data-id=" + number + "]").addClass("go");
                $("." + target + "[data-id=" + number + "]").removeClass("goAway");
            }
            //increment
            ++number;
            //continute looping till reached last ID
            if (number <= lastId) return true;
        });
    } else if ($("." + target).hasClass("go")) {
        $("." + target).addClass("goAway");
        $("." + target).removeClass("go");
    } else {
        $("." + target).addClass("go");
        $("." + target).removeClass("goAway");
    }
});
$(document.body).on("appear", ".animatedParent", function(e, $affected) {
    var ele = $(this).find(".animated");
    var parent = $(this);
    if (parent.attr("data-sequence") != undefined) {
        var firstId = $(this).find(".animated:first").attr("data-id");
        var number = firstId;
        var lastId = $(this).find(".animated:last").attr("data-id");
        $(parent).find(".animated[data-id=" + number + "]").addClass("go");
        number++;
        delay = Number(parent.attr("data-sequence"));
        $.doTimeout(delay, function() {
            $(parent).find(".animated[data-id=" + number + "]").addClass("go");
            ++number;
            if (number <= lastId) return true;
        });
    } else ele.addClass("go");
});
$(document.body).on("disappear", ".animatedParent", function(e, $affected) {
    if (!$(this).hasClass("animateOnce")) $(this).find(".animated").removeClass("go");
});
$(window).load(function() {
    $.force_appear();
});


// Typed.js | Copyright (c) 2016 Matt Boldt | www.mattboldt.com
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
!function($) {
    "use strict";
    var Typed = function Typed(el, options) {
        // chosen element to manipulate text
        this.el = $(el);
        // options
        this.options = $.extend({}, $.fn.typed.defaults, options);
        // attribute to type into
        this.isInput = this.el.is("input");
        this.attr = this.options.attr;
        // show cursor
        this.showCursor = this.isInput ? false : this.options.showCursor;
        // text content of element
        this.elContent = this.attr ? this.el.attr(this.attr) : this.el.text();
        // html or plain text
        this.contentType = this.options.contentType;
        // typing speed
        this.typeSpeed = this.options.typeSpeed;
        // add a delay before typing starts
        this.startDelay = this.options.startDelay;
        // backspacing speed
        this.backSpeed = this.options.backSpeed;
        // amount of time to wait before backspacing
        this.backDelay = this.options.backDelay;
        // div containing strings
        this.stringsElement = this.options.stringsElement;
        // input strings of text
        this.strings = this.options.strings;
        // character number position of current string
        this.strPos = 0;
        // current array position
        this.arrayPos = 0;
        // number to stop backspacing on.
        // default 0, can change depending on how many chars
        // you want to remove at the time
        this.stopNum = 0;
        // Looping logic
        this.loop = this.options.loop;
        this.loopCount = this.options.loopCount;
        this.curLoop = 0;
        // for stopping
        this.stop = false;
        // custom cursor
        this.cursorChar = this.options.cursorChar;
        // shuffle the strings
        this.shuffle = this.options.shuffle;
        // the order of strings
        this.sequence = [];
        // All systems go!
        this.build();
    };
    Typed.prototype = {
        constructor: Typed,
        init: function init() {
            // begin the loop w/ first current string (global self.strings)
            // current string will be passed as an argument each time after this
            var self = this;
            self.timeout = setTimeout(function() {
                for(var i = 0; i < self.strings.length; ++i)self.sequence[i] = i;
                // shuffle the array if true
                if (self.shuffle) self.sequence = self.shuffleArray(self.sequence);
                // Start typing
                self.typewrite(self.strings[self.sequence[self.arrayPos]], self.strPos);
            }, self.startDelay);
        },
        build: function build() {
            var self = this;
            // Insert cursor
            if (this.showCursor === true) {
                this.cursor = $('<span class="typed-cursor">' + this.cursorChar + "</span>");
                this.el.after(this.cursor);
            }
            if (this.stringsElement) {
                this.strings = [];
                this.stringsElement.hide();
                console.log(this.stringsElement.children());
                var strings = this.stringsElement.children();
                $.each(strings, function(key, value) {
                    self.strings.push($(value).html());
                });
            }
            this.init();
        },
        // pass current string state to each function, types 1 char per call
        typewrite: function typewrite(curString, curStrPos) {
            // exit when stopped
            if (this.stop === true) return;
            // varying values for setTimeout during typing
            // can't be global since number changes each time loop is executed
            var humanize = Math.round(Math.random() * 70) + this.typeSpeed;
            var self = this;
            // ------------- optional ------------- //
            // backpaces a certain string faster
            // ------------------------------------ //
            // if (self.arrayPos == 1){
            //  self.backDelay = 50;
            // }
            // else{ self.backDelay = 500; }
            // contain typing function in a timeout humanize'd delay
            self.timeout = setTimeout(function() {
                // check for an escape character before a pause value
                // format: \^\d+ .. eg: ^1000 .. should be able to print the ^ too using ^^
                // single ^ are removed from string
                var charPause = 0;
                var substr = curString.substr(curStrPos);
                if (substr.charAt(0) === "^") {
                    var skip = 1; // skip atleast 1
                    if (/^\^\d+/.test(substr)) {
                        substr = /\d+/.exec(substr)[0];
                        skip += substr.length;
                        charPause = parseInt(substr);
                    }
                    // strip out the escape character and pause value so they're not printed
                    curString = curString.substring(0, curStrPos) + curString.substring(curStrPos + skip);
                }
                if (self.contentType === "html") {
                    // skip over html tags while typing
                    var curChar = curString.substr(curStrPos).charAt(0);
                    if (curChar === "<" || curChar === "&") {
                        var tag = "";
                        var endTag = "";
                        if (curChar === "<") endTag = ">";
                        else endTag = ";";
                        while(curString.substr(curStrPos + 1).charAt(0) !== endTag){
                            tag += curString.substr(curStrPos).charAt(0);
                            curStrPos++;
                            if (curStrPos + 1 > curString.length) break;
                        }
                        curStrPos++;
                        tag += endTag;
                    }
                }
                // timeout for any pause after a character
                self.timeout = setTimeout(function() {
                    if (curStrPos === curString.length) {
                        // fires callback function
                        self.options.onStringTyped(self.arrayPos);
                        // is this the final string
                        if (self.arrayPos === self.strings.length - 1) {
                            // animation that occurs on the last typed string
                            self.options.callback();
                            self.curLoop++;
                            // quit if we wont loop back
                            if (self.loop === false || self.curLoop === self.loopCount) return;
                        }
                        self.timeout = setTimeout(function() {
                            self.backspace(curString, curStrPos);
                        }, self.backDelay);
                    } else {
                        /* call before functions if applicable */ if (curStrPos === 0) self.options.preStringTyped(self.arrayPos);
                        // start typing each new char into existing string
                        // curString: arg, self.el.html: original text inside element
                        var nextString = curString.substr(0, curStrPos + 1);
                        if (self.attr) self.el.attr(self.attr, nextString);
                        else {
                            if (self.isInput) self.el.val(nextString);
                            else if (self.contentType === "html") self.el.html(nextString);
                            else self.el.text(nextString);
                        }
                        // add characters one by one
                        curStrPos++;
                        // loop the function
                        self.typewrite(curString, curStrPos);
                    }
                // end of character pause
                }, charPause);
            // humanized value for typing
            }, humanize);
        },
        backspace: function backspace(curString, curStrPos) {
            // exit when stopped
            if (this.stop === true) return;
            // varying values for setTimeout during typing
            // can't be global since number changes each time loop is executed
            var humanize = Math.round(Math.random() * 70) + this.backSpeed;
            var self = this;
            self.timeout = setTimeout(function() {
                // ----- this part is optional ----- //
                // check string array position
                // on the first string, only delete one word
                // the stopNum actually represents the amount of chars to
                // keep in the current string. In my case it's 14.
                // if (self.arrayPos == 1){
                //  self.stopNum = 14;
                // }
                //every other time, delete the whole typed string
                // else{
                //  self.stopNum = 0;
                // }
                if (self.contentType === "html") // skip over html tags while backspacing
                {
                    if (curString.substr(curStrPos).charAt(0) === ">") {
                        var tag = "";
                        while(curString.substr(curStrPos - 1).charAt(0) !== "<"){
                            tag -= curString.substr(curStrPos).charAt(0);
                            curStrPos--;
                            if (curStrPos < 0) break;
                        }
                        curStrPos--;
                        tag += "<";
                    }
                }
                // ----- continue important stuff ----- //
                // replace text with base text + typed characters
                var nextString = curString.substr(0, curStrPos);
                if (self.attr) self.el.attr(self.attr, nextString);
                else {
                    if (self.isInput) self.el.val(nextString);
                    else if (self.contentType === "html") self.el.html(nextString);
                    else self.el.text(nextString);
                }
                // if the number (id of character in current string) is
                // less than the stop number, keep going
                if (curStrPos > self.stopNum) {
                    // subtract characters one by one
                    curStrPos--;
                    // loop the function
                    self.backspace(curString, curStrPos);
                } else if (curStrPos <= self.stopNum) {
                    self.arrayPos++;
                    if (self.arrayPos === self.strings.length) {
                        self.arrayPos = 0;
                        // Shuffle sequence again
                        if (self.shuffle) self.sequence = self.shuffleArray(self.sequence);
                        self.init();
                    } else self.typewrite(self.strings[self.sequence[self.arrayPos]], curStrPos);
                }
            // humanized value for typing
            }, humanize);
        },
        /**
		 * Shuffles the numbers in the given array.
		 * @param {Array} array
		 * @returns {Array}
		 */ shuffleArray: function shuffleArray(array) {
            var tmp, current, top = array.length;
            if (top) while(--top){
                current = Math.floor(Math.random() * (top + 1));
                tmp = array[current];
                array[current] = array[top];
                array[top] = tmp;
            }
            return array;
        },
        // Start & Stop currently not working
        // , stop: function() {
        //     var self = this;
        //     self.stop = true;
        //     clearInterval(self.timeout);
        // }
        // , start: function() {
        //     var self = this;
        //     if(self.stop === false)
        //        return;
        //     this.stop = false;
        //     this.init();
        // }
        // Reset and rebuild the element
        reset: function reset() {
            var self = this;
            clearInterval(self.timeout);
            var id = this.el.attr("id");
            this.el.empty();
            if (typeof this.cursor !== "undefined") this.cursor.remove();
            this.strPos = 0;
            this.arrayPos = 0;
            this.curLoop = 0;
            // Send the callback
            this.options.resetCallback();
        }
    };
    $.fn.typed = function(option) {
        return this.each(function() {
            var $this = $(this), data = $this.data("typed"), options = typeof option == "object" && option;
            if (data) data.reset();
            $this.data("typed", data = new Typed(this, options));
            if (typeof option == "string") data[option]();
        });
    };
    $.fn.typed.defaults = {
        strings: [
            "These are the default values...",
            "You know what you should do?",
            "Use your own!",
            "Have a great day!"
        ],
        stringsElement: null,
        // typing speed
        typeSpeed: 0,
        // time before typing starts
        startDelay: 0,
        // backspacing speed
        backSpeed: 0,
        // shuffle the strings
        shuffle: false,
        // time before backspacing
        backDelay: 500,
        // loop
        loop: false,
        // false = infinite
        loopCount: false,
        // show cursor
        showCursor: true,
        // character for cursor
        cursorChar: "|",
        // attribute to type (null == text)
        attr: null,
        // either html or text
        contentType: "html",
        // call when done callback function
        callback: function callback() {},
        // starting callback function before each string
        preStringTyped: function preStringTyped() {},
        //callback for every typed string
        onStringTyped: function onStringTyped() {},
        // callback for reset
        resetCallback: function resetCallback() {}
    };
}(window.jQuery);


/*!
 * scrollup v2.4.1
 * Url: http://markgoodyear.com/labs/scrollup/
 * Copyright (c) Mark Goodyear — @markgdyr — http://markgoodyear.com
 * License: MIT
 */ !function(l, o, e) {
    "use strict";
    l.fn.scrollUp = function(o) {
        l.data(e.body, "scrollUp") || (l.data(e.body, "scrollUp", !0), l.fn.scrollUp.init(o));
    }, l.fn.scrollUp.init = function(r) {
        var s, t, c, i, n, a, d, p = l.fn.scrollUp.settings = l.extend({}, l.fn.scrollUp.defaults, r), f = !1;
        switch(d = p.scrollTrigger ? l(p.scrollTrigger) : l("<a/>", {
            id: p.scrollName,
            href: "#top"
        }), p.scrollTitle && d.attr("title", p.scrollTitle), d.appendTo("body"), p.scrollImg || p.scrollTrigger || d.html(p.scrollText), d.css({
            display: "none",
            position: "fixed",
            zIndex: p.zIndex
        }), p.activeOverlay && l("<div/>", {
            id: p.scrollName + "-active"
        }).css({
            position: "absolute",
            top: p.scrollDistance + "px",
            width: "100%",
            borderTop: "1px dotted" + p.activeOverlay,
            zIndex: p.zIndex
        }).appendTo("body"), p.animation){
            case "fade":
                s = "fadeIn", t = "fadeOut", c = p.animationSpeed;
                break;
            case "slide":
                s = "slideDown", t = "slideUp", c = p.animationSpeed;
                break;
            default:
                s = "show", t = "hide", c = 0;
        }
        i = "top" === p.scrollFrom ? p.scrollDistance : l(e).height() - l(o).height() - p.scrollDistance, n = l(o).scroll(function() {
            l(o).scrollTop() > i ? f || (d[s](c), f = !0) : f && (d[t](c), f = !1);
        }), p.scrollTarget ? "number" == typeof p.scrollTarget ? a = p.scrollTarget : "string" == typeof p.scrollTarget && (a = Math.floor(l(p.scrollTarget).offset().top)) : a = 0, d.click(function(o) {
            o.preventDefault(), l("html, body").animate({
                scrollTop: a
            }, p.scrollSpeed, p.easingType);
        });
    }, l.fn.scrollUp.defaults = {
        scrollName: "scrollUp",
        scrollDistance: 300,
        scrollFrom: "top",
        scrollSpeed: 300,
        easingType: "linear",
        animation: "fade",
        animationSpeed: 200,
        scrollTrigger: !1,
        scrollTarget: !1,
        scrollText: "Scroll to top",
        scrollTitle: !1,
        scrollImg: !1,
        activeOverlay: !1,
        zIndex: 2147483647
    }, l.fn.scrollUp.destroy = function(r) {
        l.removeData(e.body, "scrollUp"), l("#" + l.fn.scrollUp.settings.scrollName).remove(), l("#" + l.fn.scrollUp.settings.scrollName + "-active").remove(), l.fn.jquery.split(".")[1] >= 7 ? l(o).off("scroll", r) : l(o).unbind("scroll", r);
    }, l.scrollUp = l.fn.scrollUp;
}(jQuery, window, document);


var $2d89f9a386dc68b1$exports = {};
/*
 Sticky-kit v1.1.2 | WTFPL | Leaf Corcoran 2015 | http://leafo.net
*/ (function() {
    var b, f;
    b = this.jQuery || window.jQuery;
    f = b(window);
    b.fn.stick_in_parent = function(d) {
        var A, w, J, n, B, K, p, q, k, E, t;
        null == d && (d = {});
        t = d.sticky_class;
        B = d.inner_scrolling;
        E = d.recalc_every;
        k = d.parent;
        q = d.offset_top;
        p = d.spacer;
        w = d.bottoming;
        null == q && (q = 0);
        null == k && (k = void 0);
        null == B && (B = !0);
        null == t && (t = "is_stuck");
        A = b(document);
        null == w && (w = !0);
        J = function J(a, d, n, C, F, u, r, G) {
            var v, H, m, D, I, c, g, x, y, z, h, l;
            if (!a.data("sticky_kit")) {
                a.data("sticky_kit", !0);
                I = A.height();
                g = a.parent();
                null != k && (g = g.closest(k));
                if (!g.length) throw "failed to find stick parent";
                v = m = !1;
                (h = null != p ? p && a.closest(p) : b("<div />")) && h.css("position", a.css("position"));
                x = function x() {
                    var c, f, e;
                    if (!G && (I = A.height(), c = parseInt(g.css("border-top-width"), 10), f = parseInt(g.css("padding-top"), 10), d = parseInt(g.css("padding-bottom"), 10), n = g.offset().top + c + f, C = g.height(), m && (v = m = !1, null == p && (a.insertAfter(h), h.detach()), a.css({
                        position: "",
                        top: "",
                        width: "",
                        bottom: ""
                    }).removeClass(t), e = !0), F = a.offset().top - (parseInt(a.css("margin-top"), 10) || 0) - q, u = a.outerHeight(!0), r = a.css("float"), h && h.css({
                        width: a.outerWidth(!0),
                        height: u,
                        display: a.css("display"),
                        "vertical-align": a.css("vertical-align"),
                        "float": r
                    }), e)) return l();
                };
                x();
                if (u !== C) return D = void 0, c = q, z = E, l = function l() {
                    var b, l, e, k;
                    if (!G && (e = !1, null != z && (--z, 0 >= z && (z = E, x(), e = !0)), e || A.height() === I || x(), e = f.scrollTop(), null != D && (l = e - D), D = e, m ? (w && (k = e + u + c > C + n, v && !k && (v = !1, a.css({
                        position: "fixed",
                        bottom: "",
                        top: c
                    }).trigger("sticky_kit:unbottom"))), e < F && (m = !1, c = q, null == p && ("left" !== r && "right" !== r || a.insertAfter(h), h.detach()), b = {
                        position: "",
                        width: "",
                        top: ""
                    }, a.css(b).removeClass(t).trigger("sticky_kit:unstick")), B && (b = f.height(), u + q > b && !v && (c -= l, c = Math.max(b - u, c), c = Math.min(q, c), m && a.css({
                        top: c + "px"
                    })))) : e > F && (m = !0, b = {
                        position: "fixed",
                        top: c
                    }, b.width = "border-box" === a.css("box-sizing") ? a.outerWidth() + "px" : a.width() + "px", a.css(b).addClass(t), null == p && (a.after(h), "left" !== r && "right" !== r || h.append(a)), a.trigger("sticky_kit:stick")), m && w && (null == k && (k = e + u + c > C + n), !v && k))) return v = !0, "static" === g.css("position") && g.css({
                        position: "relative"
                    }), a.css({
                        position: "absolute",
                        bottom: d,
                        top: "auto"
                    }).trigger("sticky_kit:bottom");
                }, y = function y() {
                    x();
                    return l();
                }, H = function() {
                    G = !0;
                    f.off("touchmove", l);
                    f.off("scroll", l);
                    f.off("resize", y);
                    b(document.body).off("sticky_kit:recalc", y);
                    a.off("sticky_kit:detach", H);
                    a.removeData("sticky_kit");
                    a.css({
                        position: "",
                        bottom: "",
                        top: "",
                        width: ""
                    });
                    g.position("position", "");
                    if (m) return null == p && ("left" !== r && "right" !== r || a.insertAfter(h), h.remove()), a.removeClass(t);
                }, f.on("touchmove", l), f.on("scroll", l), f.on("resize", y), b(document.body).on("sticky_kit:recalc", y), a.on("sticky_kit:detach", H), setTimeout(l, 0);
            }
        };
        n = 0;
        for(K = this.length; n < K; n++)d = this[n], J(b(d));
        return this;
    };
}).call($2d89f9a386dc68b1$exports);


var $33dc6d62db6353a8$exports = {};
/*! picturefill - v3.0.2 - 2016-02-12
 * https://scottjehl.github.io/picturefill/
 * Copyright (c) 2016 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT
 */ !function(a) {
    var b = navigator.userAgent;
    a.HTMLPictureElement && /ecko/.test(b) && b.match(/rv\:(\d+)/) && RegExp.$1 < 45 && addEventListener("resize", function() {
        var b, c = document.createElement("source"), d = function d(a) {
            var b, d, e = a.parentNode;
            "PICTURE" === e.nodeName.toUpperCase() ? (b = c.cloneNode(), e.insertBefore(b, e.firstElementChild), setTimeout(function() {
                e.removeChild(b);
            })) : (!a._pfLastSize || a.offsetWidth > a._pfLastSize) && (a._pfLastSize = a.offsetWidth, d = a.sizes, a.sizes += ",100vw", setTimeout(function() {
                a.sizes = d;
            }));
        }, e = function e() {
            var _$a, b = document.querySelectorAll("picture > img, img[srcset][sizes]");
            for(_$a = 0; _$a < b.length; _$a++)d(b[_$a]);
        }, f = function f() {
            clearTimeout(b), b = setTimeout(e, 99);
        }, g = a.matchMedia && matchMedia("(orientation: landscape)"), h = function h() {
            f(), g && g.addListener && g.addListener(f);
        };
        return c.srcset = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", /^[c|i]|d$/.test(document.readyState || "") ? h() : document.addEventListener("DOMContentLoaded", h), f;
    }());
}(window), function(a, b, c) {
    "use strict";
    function d(a) {
        return " " === a || "	" === a || "\n" === a || "\f" === a || "\r" === a;
    }
    function e(b, c) {
        var d = new a.Image;
        return d.onerror = function() {
            A[b] = !1, ba();
        }, d.onload = function() {
            A[b] = 1 === d.width, ba();
        }, d.src = c, "pending";
    }
    function f() {
        M = !1, P = a.devicePixelRatio, N = {}, O = {}, s.DPR = P || 1, Q.width = Math.max(a.innerWidth || 0, z.clientWidth), Q.height = Math.max(a.innerHeight || 0, z.clientHeight), Q.vw = Q.width / 100, Q.vh = Q.height / 100, r = [
            Q.height,
            Q.width,
            P
        ].join("-"), Q.em = s.getEmValue(), Q.rem = Q.em;
    }
    function g(a, b, c, d) {
        var _$e, f, g, h;
        return "saveData" === B.algorithm ? a > 2.7 ? h = c + 1 : (f = b - c, _$e = Math.pow(a - .6, 1.5), g = f * _$e, d && (g += .1 * _$e), h = a + g) : h = c > 1 ? Math.sqrt(a * b) : a, h > c;
    }
    function h(a) {
        var _$b, c = s.getSet(a), d = !1;
        "pending" !== c && (d = r, c && (_$b = s.setRes(c), s.applySetCandidate(_$b, a))), a[s.ns].evaled = d;
    }
    function i(a, b) {
        return a.res - b.res;
    }
    function j(a, b, c) {
        var d;
        return !c && b && (c = a[s.ns].sets, c = c && c[c.length - 1]), d = k(b, c), d && (b = s.makeUrl(b), a[s.ns].curSrc = b, a[s.ns].curCan = d, d.res || aa(d, d.set.sizes)), d;
    }
    function k(a, b) {
        var c, d, _$e;
        if (a && b) {
            for(_$e = s.parseSet(b), a = s.makeUrl(a), c = 0; c < _$e.length; c++)if (a === s.makeUrl(_$e[c].url)) {
                d = _$e[c];
                break;
            }
        }
        return d;
    }
    function l(a, b) {
        var c, d, _$e, f, g = a.getElementsByTagName("source");
        for(c = 0, d = g.length; d > c; c++)_$e = g[c], _$e[s.ns] = !0, f = _$e.getAttribute("srcset"), f && b.push({
            srcset: f,
            media: _$e.getAttribute("media"),
            type: _$e.getAttribute("type"),
            sizes: _$e.getAttribute("sizes")
        });
    }
    function m(a, b) {
        function c(b) {
            var _$c, d = b.exec(a.substring(m));
            return d ? (_$c = d[0], m += _$c.length, _$c) : void 0;
        }
        function e() {
            var _$a, _$c, d, _$e, _$f, i, j, k, l, m = !1, o = {};
            for(_$e = 0; _$e < h.length; _$e++)_$f = h[_$e], i = _$f[_$f.length - 1], j = _$f.substring(0, _$f.length - 1), k = parseInt(j, 10), l = parseFloat(j), X.test(j) && "w" === i ? ((_$a || _$c) && (m = !0), 0 === k ? m = !0 : _$a = k) : Y.test(j) && "x" === i ? ((_$a || _$c || d) && (m = !0), 0 > l ? m = !0 : _$c = l) : X.test(j) && "h" === i ? ((d || _$c) && (m = !0), 0 === k ? m = !0 : d = k) : m = !0;
            m || (o.url = g, _$a && (o.w = _$a), _$c && (o.d = _$c), d && (o.h = d), d || _$c || _$a || (o.d = 1), 1 === o.d && (b.has1x = !0), o.set = b, n.push(o));
        }
        function f() {
            for(c(T), i = "", j = "in descriptor";;){
                if (k = a.charAt(m), "in descriptor" === j) {
                    if (d(k)) i && (h.push(i), i = "", j = "after descriptor");
                    else {
                        if ("," === k) return m += 1, i && h.push(i), void e();
                        if ("(" === k) i += k, j = "in parens";
                        else {
                            if ("" === k) return i && h.push(i), void e();
                            i += k;
                        }
                    }
                } else if ("in parens" === j) {
                    if (")" === k) i += k, j = "in descriptor";
                    else {
                        if ("" === k) return h.push(i), void e();
                        i += k;
                    }
                } else if ("after descriptor" === j) {
                    if (d(k)) ;
                    else {
                        if ("" === k) return void e();
                        j = "in descriptor", m -= 1;
                    }
                }
                m += 1;
            }
        }
        for(var g, h, i, j, k, l = a.length, m = 0, n = [];;){
            if (c(U), m >= l) return n;
            g = c(V), h = [], "," === g.slice(-1) ? (g = g.replace(W, ""), e()) : f();
        }
    }
    function n(a) {
        function b(a) {
            function b() {
                f && (g.push(f), f = "");
            }
            function c() {
                g[0] && (h.push(g), g = []);
            }
            for(var _$e, f = "", g = [], h = [], i = 0, j = 0, k = !1;;){
                if (_$e = a.charAt(j), "" === _$e) return b(), c(), h;
                if (k) {
                    if ("*" === _$e && "/" === a[j + 1]) {
                        k = !1, j += 2, b();
                        continue;
                    }
                    j += 1;
                } else {
                    if (d(_$e)) {
                        if (a.charAt(j - 1) && d(a.charAt(j - 1)) || !f) {
                            j += 1;
                            continue;
                        }
                        if (0 === i) {
                            b(), j += 1;
                            continue;
                        }
                        _$e = " ";
                    } else if ("(" === _$e) i += 1;
                    else if (")" === _$e) i -= 1;
                    else {
                        if ("," === _$e) {
                            b(), c(), j += 1;
                            continue;
                        }
                        if ("/" === _$e && "*" === a.charAt(j + 1)) {
                            k = !0, j += 2;
                            continue;
                        }
                    }
                    f += _$e, j += 1;
                }
            }
        }
        function c(a) {
            return k.test(a) && parseFloat(a) >= 0 ? !0 : l.test(a) ? !0 : "0" === a || "-0" === a || "+0" === a ? !0 : !1;
        }
        var _$e, f, g, h, i, j, k = /^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i, l = /^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;
        for(f = b(a), g = f.length, _$e = 0; g > _$e; _$e++)if (h = f[_$e], i = h[h.length - 1], c(i)) {
            if (j = i, h.pop(), 0 === h.length) return j;
            if (h = h.join(" "), s.matchesMedia(h)) return j;
        }
        return "100vw";
    }
    b.createElement("picture");
    var o, p, q, r, s = {}, t = !1, u = function u() {}, v = b.createElement("img"), w = v.getAttribute, x = v.setAttribute, y = v.removeAttribute, z = b.documentElement, A = {}, B = {
        algorithm: ""
    }, C = "data-pfsrc", D = C + "set", E = navigator.userAgent, F = /rident/.test(E) || /ecko/.test(E) && E.match(/rv\:(\d+)/) && RegExp.$1 > 35, G = "currentSrc", H = /\s+\+?\d+(e\d+)?w/, I = /(\([^)]+\))?\s*(.+)/, J = a.picturefillCFG, K = "position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)", L = "font-size:100%!important;", M = !0, N = {}, O = {}, P = a.devicePixelRatio, Q = {
        px: 1,
        "in": 96
    }, R = b.createElement("a"), S = !1, T = /^[ \t\n\r\u000c]+/, U = /^[, \t\n\r\u000c]+/, V = /^[^ \t\n\r\u000c]+/, W = /[,]+$/, X = /^\d+$/, Y = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, Z = function Z(a, b, c, d) {
        a.addEventListener ? a.addEventListener(b, c, d || !1) : a.attachEvent && a.attachEvent("on" + b, c);
    }, $ = function $(a) {
        var _$b = {};
        return function(c) {
            return c in _$b || (_$b[c] = a(c)), _$b[c];
        };
    }, _ = function() {
        var _$a = /^([\d\.]+)(em|vw|px)$/, _$b = function b() {
            for(var _$a = arguments, _$b = 0, c = _$a[0]; (++_$b in _$a);)c = c.replace(_$a[_$b], _$a[++_$b]);
            return c;
        }, c = $(function(a) {
            return "return " + _$b((a || "").toLowerCase(), /\band\b/g, "&&", /,/g, "||", /min-([a-z-\s]+):/g, "e.$1>=", /max-([a-z-\s]+):/g, "e.$1<=", /calc([^)]+)/g, "($1)", /(\d+[\.]*[\d]*)([a-z]+)/g, "($1 * e.$2)", /^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/gi, "") + ";";
        });
        return function(b, d) {
            var _$e;
            if (!(b in N)) {
                if (N[b] = !1, d && (_$e = b.match(_$a))) N[b] = _$e[1] * Q[_$e[2]];
                else try {
                    N[b] = new Function("e", c(b))(Q);
                } catch (f) {}
            }
            return N[b];
        };
    }(), aa = function aa(a, b) {
        return a.w ? (a.cWidth = s.calcListLength(b || "100vw"), a.res = a.w / a.cWidth) : a.res = a.d, a;
    }, ba = function ba(a) {
        if (t) {
            var c, d, _$e, f = a || {};
            if (f.elements && 1 === f.elements.nodeType && ("IMG" === f.elements.nodeName.toUpperCase() ? f.elements = [
                f.elements
            ] : (f.context = f.elements, f.elements = null)), c = f.elements || s.qsa(f.context || b, f.reevaluate || f.reselect ? s.sel : s.selShort), _$e = c.length) {
                for(s.setupRun(f), S = !0, d = 0; _$e > d; d++)s.fillImg(c[d], f);
                s.teardownRun(f);
            }
        }
    };
    o = a.console && console.warn ? function o(a) {
        console.warn(a);
    } : u, G in v || (G = "src"), A["image/jpeg"] = !0, A["image/gif"] = !0, A["image/png"] = !0, A["image/svg+xml"] = b.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image", "1.1"), s.ns = ("pf" + (new Date).getTime()).substr(0, 9), s.supSrcset = "srcset" in v, s.supSizes = "sizes" in v, s.supPicture = !!a.HTMLPictureElement, s.supSrcset && s.supPicture && !s.supSizes && !function(a) {
        v.srcset = "data:,a", a.src = "data:,a", s.supSrcset = v.complete === a.complete, s.supPicture = s.supSrcset && s.supPicture;
    }(b.createElement("img")), s.supSrcset && !s.supSizes ? !function() {
        var _$a = "data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==", c = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", d = b.createElement("img"), _$e = function e() {
            var _$a = d.width;
            2 === _$a && (s.supSizes = !0), q = s.supSrcset && !s.supSizes, t = !0, setTimeout(ba);
        };
        d.onload = _$e, d.onerror = _$e, d.setAttribute("sizes", "9px"), d.srcset = c + " 1w," + _$a + " 9w", d.src = c;
    }() : t = !0, s.selShort = "picture>img,img[srcset]", s.sel = s.selShort, s.cfg = B, s.DPR = P || 1, s.u = Q, s.types = A, s.setSize = u, s.makeUrl = $(function(a) {
        return R.href = a, R.href;
    }), s.qsa = function(a, b) {
        return "querySelector" in a ? a.querySelectorAll(b) : [];
    }, s.matchesMedia = function() {
        return a.matchMedia && (matchMedia("(min-width: 0.1em)") || {}).matches ? s.matchesMedia = function(a) {
            return !a || matchMedia(a).matches;
        } : s.matchesMedia = s.mMQ, s.matchesMedia.apply(this, arguments);
    }, s.mMQ = function(a) {
        return a ? _(a) : !0;
    }, s.calcLength = function(a) {
        var _$b = _(a, !0) || !1;
        return 0 > _$b && (_$b = !1), _$b;
    }, s.supportsType = function(a) {
        return a ? A[a] : !0;
    }, s.parseSize = $(function(a) {
        var _$b = (a || "").match(I);
        return {
            media: _$b && _$b[1],
            length: _$b && _$b[2]
        };
    }), s.parseSet = function(a) {
        return a.cands || (a.cands = m(a.srcset, a)), a.cands;
    }, s.getEmValue = function() {
        var _$a;
        if (!p && (_$a = b.body)) {
            var c = b.createElement("div"), d = z.style.cssText, _$e = _$a.style.cssText;
            c.style.cssText = K, z.style.cssText = L, _$a.style.cssText = L, _$a.appendChild(c), p = c.offsetWidth, _$a.removeChild(c), p = parseFloat(p, 10), z.style.cssText = d, _$a.style.cssText = _$e;
        }
        return p || 16;
    }, s.calcListLength = function(a) {
        if (!(a in O) || B.uT) {
            var _$b = s.calcLength(n(a));
            O[a] = _$b ? _$b : Q.width;
        }
        return O[a];
    }, s.setRes = function(a) {
        var _$b;
        if (a) {
            _$b = s.parseSet(a);
            for(var c = 0, d = _$b.length; d > c; c++)aa(_$b[c], a.sizes);
        }
        return _$b;
    }, s.setRes.res = aa, s.applySetCandidate = function(a, b) {
        if (a.length) {
            var c, d, _$e, f, h, k, l, m, n, o = b[s.ns], p = s.DPR;
            if (k = o.curSrc || b[G], l = o.curCan || j(b, k, a[0].set), l && l.set === a[0].set && (n = F && !b.complete && l.res - .1 > p, n || (l.cached = !0, l.res >= p && (h = l))), !h) {
                for(a.sort(i), f = a.length, h = a[f - 1], d = 0; f > d; d++)if (c = a[d], c.res >= p) {
                    _$e = d - 1, h = a[_$e] && (n || k !== s.makeUrl(c.url)) && g(a[_$e].res, c.res, p, a[_$e].cached) ? a[_$e] : c;
                    break;
                }
            }
            h && (m = s.makeUrl(h.url), o.curSrc = m, o.curCan = h, m !== k && s.setSrc(b, h), s.setSize(b));
        }
    }, s.setSrc = function(a, b) {
        var c;
        a.src = b.url, "image/svg+xml" === b.set.type && (c = a.style.width, a.style.width = a.offsetWidth + 1 + "px", a.offsetWidth + 1 && (a.style.width = c));
    }, s.getSet = function(a) {
        var _$b, c, d, _$e = !1, f = a[s.ns].sets;
        for(_$b = 0; _$b < f.length && !_$e; _$b++)if (c = f[_$b], c.srcset && s.matchesMedia(c.media) && (d = s.supportsType(c.type))) {
            "pending" === d && (c = d), _$e = c;
            break;
        }
        return _$e;
    }, s.parseSets = function(a, b, d) {
        var _$e, f, g, h, i = b && "PICTURE" === b.nodeName.toUpperCase(), j = a[s.ns];
        (j.src === c || d.src) && (j.src = w.call(a, "src"), j.src ? x.call(a, C, j.src) : y.call(a, C)), (j.srcset === c || d.srcset || !s.supSrcset || a.srcset) && (_$e = w.call(a, "srcset"), j.srcset = _$e, h = !0), j.sets = [], i && (j.pic = !0, l(b, j.sets)), j.srcset ? (f = {
            srcset: j.srcset,
            sizes: w.call(a, "sizes")
        }, j.sets.push(f), g = (q || j.src) && H.test(j.srcset || ""), g || !j.src || k(j.src, f) || f.has1x || (f.srcset += ", " + j.src, f.cands.push({
            url: j.src,
            d: 1,
            set: f
        }))) : j.src && j.sets.push({
            srcset: j.src,
            sizes: null
        }), j.curCan = null, j.curSrc = c, j.supported = !(i || f && !s.supSrcset || g && !s.supSizes), h && s.supSrcset && !j.supported && (_$e ? (x.call(a, D, _$e), a.srcset = "") : y.call(a, D)), j.supported && !j.srcset && (!j.src && a.src || a.src !== s.makeUrl(j.src)) && (null === j.src ? a.removeAttribute("src") : a.src = j.src), j.parsed = !0;
    }, s.fillImg = function(a, b) {
        var c, d = b.reselect || b.reevaluate;
        a[s.ns] || (a[s.ns] = {}), c = a[s.ns], (d || c.evaled !== r) && ((!c.parsed || b.reevaluate) && s.parseSets(a, a.parentNode, b), c.supported ? c.evaled = r : h(a));
    }, s.setupRun = function() {
        (!S || M || P !== a.devicePixelRatio) && f();
    }, s.supPicture ? (ba = u, s.fillImg = u) : !function() {
        var c, d = a.attachEvent ? /d$|^c/ : /d$|^c|^i/, _$e = function e() {
            var _$a = b.readyState || "";
            f = setTimeout(_$e, "loading" === _$a ? 200 : 999), b.body && (s.fillImgs(), c = c || d.test(_$a), c && clearTimeout(f));
        }, f = setTimeout(_$e, b.body ? 9 : 99), g = function g(a, b) {
            var c, d, _$e = function e() {
                var f = new Date - d;
                b > f ? c = setTimeout(_$e, b - f) : (c = null, a());
            };
            return function() {
                d = new Date, c || (c = setTimeout(_$e, b));
            };
        }, h = z.clientHeight, i = function i() {
            M = Math.max(a.innerWidth || 0, z.clientWidth) !== Q.width || z.clientHeight !== h, h = z.clientHeight, M && s.fillImgs();
        };
        Z(a, "resize", g(i, 99)), Z(b, "readystatechange", _$e);
    }(), s.picturefill = ba, s.fillImgs = ba, s.teardownRun = u, ba._ = s, a.picturefillCFG = {
        pf: s,
        push: function push(a) {
            var _$b = a.shift();
            "function" == typeof s[_$b] ? s[_$b].apply(s, a) : (B[_$b] = a[0], S && s.fillImgs({
                reselect: !0
            }));
        }
    };
    for(; J && J.length;)a.picturefillCFG.push(J.shift());
    a.picturefill = ba, "object" == typeof $33dc6d62db6353a8$exports ? $33dc6d62db6353a8$exports = ba : "function" == typeof define && define.amd && define("picturefill", function() {
        return ba;
    }), s.supPicture || (A["image/webp"] = e("image/webp", "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA=="));
}(window, document);


var $31467fba5e5d38e9$exports = {};
/*! npm.im/object-fit-images 3.2.4 */ "use strict";
var $31467fba5e5d38e9$var$OFI = "bfred-it:object-fit-images";
var $31467fba5e5d38e9$var$propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
var $31467fba5e5d38e9$var$testImg = typeof Image === "undefined" ? {
    style: {
        "object-position": 1
    }
} : new Image();
var $31467fba5e5d38e9$var$supportsObjectFit = "object-fit" in $31467fba5e5d38e9$var$testImg.style;
var $31467fba5e5d38e9$var$supportsObjectPosition = "object-position" in $31467fba5e5d38e9$var$testImg.style;
var $31467fba5e5d38e9$var$supportsOFI = "background-size" in $31467fba5e5d38e9$var$testImg.style;
var $31467fba5e5d38e9$var$supportsCurrentSrc = typeof $31467fba5e5d38e9$var$testImg.currentSrc === "string";
var $31467fba5e5d38e9$var$nativeGetAttribute = $31467fba5e5d38e9$var$testImg.getAttribute;
var $31467fba5e5d38e9$var$nativeSetAttribute = $31467fba5e5d38e9$var$testImg.setAttribute;
var $31467fba5e5d38e9$var$autoModeEnabled = false;
function $31467fba5e5d38e9$var$createPlaceholder(w, h) {
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E";
}
function $31467fba5e5d38e9$var$polyfillCurrentSrc(el) {
    if (el.srcset && !$31467fba5e5d38e9$var$supportsCurrentSrc && window.picturefill) {
        var pf = window.picturefill._;
        // parse srcset with picturefill where currentSrc isn't available
        if (!el[pf.ns] || !el[pf.ns].evaled) // force synchronous srcset parsing
        pf.fillImg(el, {
            reselect: true
        });
        if (!el[pf.ns].curSrc) {
            // force picturefill to parse srcset
            el[pf.ns].supported = false;
            pf.fillImg(el, {
                reselect: true
            });
        }
        // retrieve parsed currentSrc, if any
        el.currentSrc = el[pf.ns].curSrc || el.src;
    }
}
function $31467fba5e5d38e9$var$getStyle(el) {
    var style = getComputedStyle(el).fontFamily;
    var parsed;
    var props = {};
    while((parsed = $31467fba5e5d38e9$var$propRegex.exec(style)) !== null)props[parsed[1]] = parsed[2];
    return props;
}
function $31467fba5e5d38e9$var$setPlaceholder(img, width, height) {
    // Default: fill width, no height
    var placeholder = $31467fba5e5d38e9$var$createPlaceholder(width || 1, height || 0);
    // Only set placeholder if it's different
    if ($31467fba5e5d38e9$var$nativeGetAttribute.call(img, "src") !== placeholder) $31467fba5e5d38e9$var$nativeSetAttribute.call(img, "src", placeholder);
}
function $31467fba5e5d38e9$var$onImageReady(img, callback) {
    // naturalWidth is only available when the image headers are loaded,
    // this loop will poll it every 100ms.
    if (img.naturalWidth) callback(img);
    else setTimeout($31467fba5e5d38e9$var$onImageReady, 100, img, callback);
}
function $31467fba5e5d38e9$var$fixOne(el) {
    var style = $31467fba5e5d38e9$var$getStyle(el);
    var ofi = el[$31467fba5e5d38e9$var$OFI];
    style["object-fit"] = style["object-fit"] || "fill"; // default value
    // Avoid running where unnecessary, unless OFI had already done its deed
    if (!ofi.img) {
        // fill is the default behavior so no action is necessary
        if (style["object-fit"] === "fill") return;
        // Where object-fit is supported and object-position isn't (Safari < 10)
        if (!ofi.skipTest && // unless user wants to apply regardless of browser support
        $31467fba5e5d38e9$var$supportsObjectFit && // if browser already supports object-fit
        !style["object-position"] // unless object-position is used
        ) return;
    }
    // keep a clone in memory while resetting the original to a blank
    if (!ofi.img) {
        ofi.img = new Image(el.width, el.height);
        ofi.img.srcset = $31467fba5e5d38e9$var$nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
        ofi.img.src = $31467fba5e5d38e9$var$nativeGetAttribute.call(el, "data-ofi-src") || el.src;
        // preserve for any future cloneNode calls
        // https://github.com/bfred-it/object-fit-images/issues/53
        $31467fba5e5d38e9$var$nativeSetAttribute.call(el, "data-ofi-src", el.src);
        if (el.srcset) $31467fba5e5d38e9$var$nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
        $31467fba5e5d38e9$var$setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);
        // remove srcset because it overrides src
        if (el.srcset) el.srcset = "";
        try {
            $31467fba5e5d38e9$var$keepSrcUsable(el);
        } catch (err) {
            if (window.console) console.warn("https://bit.ly/ofi-old-browser");
        }
    }
    $31467fba5e5d38e9$var$polyfillCurrentSrc(ofi.img);
    el.style.backgroundImage = 'url("' + (ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"') + '")';
    el.style.backgroundPosition = style["object-position"] || "center";
    el.style.backgroundRepeat = "no-repeat";
    el.style.backgroundOrigin = "content-box";
    if (/scale-down/.test(style["object-fit"])) $31467fba5e5d38e9$var$onImageReady(ofi.img, function() {
        if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) el.style.backgroundSize = "contain";
        else el.style.backgroundSize = "auto";
    });
    else el.style.backgroundSize = style["object-fit"].replace("none", "auto").replace("fill", "100% 100%");
    $31467fba5e5d38e9$var$onImageReady(ofi.img, function(img) {
        $31467fba5e5d38e9$var$setPlaceholder(el, img.naturalWidth, img.naturalHeight);
    });
}
function $31467fba5e5d38e9$var$keepSrcUsable(el) {
    var descriptors = {
        get: function get(prop) {
            return el[$31467fba5e5d38e9$var$OFI].img[prop ? prop : "src"];
        },
        set: function set(value, prop) {
            el[$31467fba5e5d38e9$var$OFI].img[prop ? prop : "src"] = value;
            $31467fba5e5d38e9$var$nativeSetAttribute.call(el, "data-ofi-" + prop, value); // preserve for any future cloneNode
            $31467fba5e5d38e9$var$fixOne(el);
            return value;
        }
    };
    Object.defineProperty(el, "src", descriptors);
    Object.defineProperty(el, "currentSrc", {
        get: function get() {
            return descriptors.get("currentSrc");
        }
    });
    Object.defineProperty(el, "srcset", {
        get: function get() {
            return descriptors.get("srcset");
        },
        set: function set(ss) {
            return descriptors.set(ss, "srcset");
        }
    });
}
function $31467fba5e5d38e9$var$hijackAttributes() {
    function getOfiImageMaybe(el, name) {
        return el[$31467fba5e5d38e9$var$OFI] && el[$31467fba5e5d38e9$var$OFI].img && (name === "src" || name === "srcset") ? el[$31467fba5e5d38e9$var$OFI].img : el;
    }
    if (!$31467fba5e5d38e9$var$supportsObjectPosition) {
        HTMLImageElement.prototype.getAttribute = function(name) {
            return $31467fba5e5d38e9$var$nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
        };
        HTMLImageElement.prototype.setAttribute = function(name, value) {
            return $31467fba5e5d38e9$var$nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
        };
    }
}
function $31467fba5e5d38e9$var$fix(imgs, opts) {
    var startAutoMode = !$31467fba5e5d38e9$var$autoModeEnabled && !imgs;
    opts = opts || {};
    imgs = imgs || "img";
    if ($31467fba5e5d38e9$var$supportsObjectPosition && !opts.skipTest || !$31467fba5e5d38e9$var$supportsOFI) return false;
    // use imgs as a selector or just select all images
    if (imgs === "img") imgs = document.getElementsByTagName("img");
    else if (typeof imgs === "string") imgs = document.querySelectorAll(imgs);
    else if (!("length" in imgs)) imgs = [
        imgs
    ];
    // apply fix to all
    for(var i = 0; i < imgs.length; i++){
        imgs[i][$31467fba5e5d38e9$var$OFI] = imgs[i][$31467fba5e5d38e9$var$OFI] || {
            skipTest: opts.skipTest
        };
        $31467fba5e5d38e9$var$fixOne(imgs[i]);
    }
    if (startAutoMode) {
        document.body.addEventListener("load", function(e) {
            if (e.target.tagName === "IMG") $31467fba5e5d38e9$var$fix(e.target, {
                skipTest: opts.skipTest
            });
        }, true);
        $31467fba5e5d38e9$var$autoModeEnabled = true;
        imgs = "img"; // reset to a generic selector for watchMQ
    }
    // if requested, watch media queries for object-fit change
    if (opts.watchMQ) window.addEventListener("resize", $31467fba5e5d38e9$var$fix.bind(null, imgs, {
        skipTest: opts.skipTest
    }));
}
$31467fba5e5d38e9$var$fix.supportsObjectFit = $31467fba5e5d38e9$var$supportsObjectFit;
$31467fba5e5d38e9$var$fix.supportsObjectPosition = $31467fba5e5d38e9$var$supportsObjectPosition;
$31467fba5e5d38e9$var$hijackAttributes();
$31467fba5e5d38e9$exports = $31467fba5e5d38e9$var$fix;


var $a4aeaafd6e74a8fe$export$2e2bcd8739ae039 = function(el) {
    var mapElement = document.getElementById(el);
    if (mapElement) {
        var init = function init() {
            var mapOptions = {
                zoom: 15,
                scrollwheel: false,
                streetViewControl: false,
                mapTypeControl: false,
                center: new google.maps.LatLng(52.370224, 4.627572),
                styles: [
                    {
                        "featureType": "administrative",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#98458a"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [
                            {
                                "saturation": -100
                            },
                            {
                                "lightness": 45
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#e2e2e2"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    }
                ]
            };
            var map = new google.maps.Map(mapElement, mapOptions);
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(52.371817, 4.627572),
                map: map,
                title: "AVT Benelux!"
            });
        };
        google.maps.event.addDomListener(window, "load", init);
    }
};


var $01c4a72039533074$exports = {};

$01c4a72039533074$exports = (parcelRequire("03SX2"));


// Detect mobile device
function $6e15c66c5bf5d010$export$8de52386ea28ce8f() {
    var check = false;
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}
function $6e15c66c5bf5d010$export$5dacdde460c8d918() {
    if (window.NodeList && !NodeList.prototype.forEach) NodeList.prototype.forEach = function(callback, thisArg) {
        thisArg = thisArg || window;
        for(var i = 0; i < this.length; i++)callback.call(thisArg, this[i], i, this);
    };
}
function $6e15c66c5bf5d010$export$7cd7c12df529a1c3() {
    if (!String.prototype.includes) String.prototype.includes = function(search, start) {
        "use strict";
        if (typeof start !== "number") start = 0;
        if (start + search.length > this.length) return false;
        else return this.indexOf(search, start) !== -1;
    };
}



(parcelRequire("x1Mg0")).polyfill();
(0, $6e15c66c5bf5d010$export$5dacdde460c8d918)();
(0, $6e15c66c5bf5d010$export$7cd7c12df529a1c3)();
var $cc7b464ffff971a6$var$displayMatches = function(matches, query, container, searchBar, backdrop) {
    searchBar.classList.add("focused");
    backdrop.classList.add("focused");
    // container.style.display = 'block'
    var terms = [];
    var items = [];
    console.log(matches);
    matches.forEach(function(match) {
        if (match.term_id) {
            var title = match.title, url = match.url, type = match.type, img = match.img, price = match.price;
            var term = '\n			<a href="'.concat(match.url && match.url || "/categorie/" + match.slug, '" class="search-bar-results__item type-').concat(type, '">    \n				').concat(img ? "<img src=" + img + ">" : "", '  \n				<span class="result-content">  \n					<span class="result-type">\n						').concat(type === "Pagina" ? type : "", "\n						").concat(type === "Blog" ? type : "", "\n					</span>   \n					").concat(!match.term_id ? '<span class="result-title">' + title + "</span>" : "", "\n					").concat(match.term_id ? '<span class="result-title">' + match.name + "</span>" : "", "\n				</span>\n\n			</a>");
            terms.push(term);
        } else {
            var title1 = match.title, url1 = match.url, type1 = match.type, img1 = match.img, price1 = match.price;
            var item = '\n				<a href="'.concat(match.url && match.url || "/categorie/" + match.slug, '" class="search-bar-results__item type-').concat(type1, '">    \n					').concat(img1 ? "<img src=" + img1 + ">" : "", '  \n					<span class="result-content">  \n						<span class="result-type">\n							').concat(type1 === "Pagina" ? type1 : "", "\n							").concat(type1 === "Blog" ? type1 : "", "\n						</span>   \n						").concat(!match.term_id ? '<span class="result-title">' + title1 + "</span>" : "", "\n						").concat(match.term_id ? '<span class="result-title">' + match.name + "</span>" : "", "\n					</span>\n\n				</a>");
            items.push(item);
        }
    });
    container.innerHTML = "";
    if (typeof terms !== "undefined" && terms.length > 0) {
        var termsList = document.createElement("div");
        termsList.classList.add("search-bar-results-terms");
        termsList.innerHTML = terms.join("");
        container.appendChild(termsList);
    }
    if (typeof items !== "undefined" && items.length > 0) {
        var itemsList = document.createElement("div");
        itemsList.classList.add("search-bar-results-items");
        itemsList.innerHTML = items.join("");
        container.appendChild(itemsList);
    }
    query.length && items.length;
};
var $cc7b464ffff971a6$var$findMatches = function(query, results, container, searchBar, backdrop) {
    var matches = results.filter(function(result) {
        var title = result.title, name = result.name, excerpt = result.excerpt;
        if (title) return title.toLowerCase().includes(query.toLowerCase()) || excerpt.toLowerCase().includes(query.toLowerCase());
        else if (name) return name.toLowerCase().includes(query.toLowerCase());
        else return;
    });
    $cc7b464ffff971a6$var$displayMatches(matches, query, container, searchBar, backdrop);
};
function $cc7b464ffff971a6$export$2e2bcd8739ae039(parentSelector) {
    var parent = document.querySelector(parentSelector);
    if (!parent) return;
    var input = parent.querySelector(".search-bar-field");
    var backdrop = parent.querySelector(".search-bar-backdrop");
    if (!input) return;
    var searchBar = input.closest(".search-bar");
    var container = searchBar.querySelector(".search-bar-results");
    var results = null;
    (0, (/*@__PURE__*/$parcel$interopDefault($01c4a72039533074$exports))).get("/wp-json/rest/data").then(function(res) {
        results = res.data;
        input.parentElement.classList.remove("loading");
    }).catch(function(err) {
        return console.log(err);
    });
    backdrop.addEventListener("click", function() {
        searchBar.classList.remove("focused");
        backdrop.classList.remove("focused");
    });
    input.addEventListener("keyup", function() {
        var query = input.value;
        if (query.length > 1) $cc7b464ffff971a6$var$findMatches(query, results, container, searchBar, backdrop);
        else {
            searchBar.classList.remove("focused");
            backdrop.classList.remove("focused");
        // container.style.display = 'none'
        }
    });
// input.addEventListener('blur', () => {
// 	container.style.display = 'none'
// })
}


(0, $cc7b464ffff971a6$export$2e2bcd8739ae039)(".header-search-bar");
(0, $a4aeaafd6e74a8fe$export$2e2bcd8739ae039)("map");
// Object-fit fix
(0, (/*@__PURE__*/$parcel$interopDefault($31467fba5e5d38e9$exports)))();
// Search products OLD
// getProducts();
// const searchInput = document.querySelector('.search-field');
// const searchResults = document.querySelector('.search-form__results');
// searchInput.addEventListener('keyup', (e) => {
//     const value = e.target.value;
//     getResults(value);
//     searchResults.style.display = 'flex';
//     if (value.length === 0) {
//         searchResults.style.display = 'none';
//     }
// });
$("#typed").typed({
    stringsElement: $("#typed-strings"),
    typeSpeed: 25,
    startDelay: 1000
});
$(".cloud .cloud--title").each(function() {
    var text = $(this).text();
    $(this).text(text.replace("Spraakherkenning voor", " "));
});
$.scrollUp({
    scrollText: '<svg class="middle" height="25" width="25"><use xlink:href="#pijl-omhoog"></use></svg>',
    scrollDistance: 500
});
/* Accordion bij meestgestelde vragen */ $(".accordion").accordion({
    "transitionSpeed": 400
});
/* Search zichtbaar maken */ $(".search-icon").click(function() {
    $(".header--search").toggleClass("open");
    $(".search-field").focus();
});
/* Mobiele shop-filters zichtbaar maken */ $(function() {
    $(".shop--sidebar > div").click(function() {
        $(".shop--sidebar").toggleClass("open");
    });
});
/* Floating sidebar op shop page */ if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) $(".shop--sidebar aside").stick_in_parent({
    offset_top: 110
});
$("#aanhef_field").insertBefore("#billing_first_name_field");
/* Testimonials slider */ var $c55bff8fb8cf358b$var$$window = $(window), $c55bff8fb8cf358b$var$flexslider = {
    vars: {}
};
// tiny helper function to add breakpoints
function $c55bff8fb8cf358b$var$getGridSize() {
    return window.innerWidth < 600 ? 1 : window.innerWidth < 900 ? 2 : 2;
}
$c55bff8fb8cf358b$var$$window.load(function() {
    $(".testimonials--slider").flexslider({
        animation: "slide",
        directionNav: false,
        animationLoop: false,
        itemWidth: 210,
        slideshowSpeed: 13000,
        itemMargin: 5,
        minItems: $c55bff8fb8cf358b$var$getGridSize(),
        maxItems: $c55bff8fb8cf358b$var$getGridSize() // use function to pull in initial value
    });
});
// check grid size on resize event
$c55bff8fb8cf358b$var$$window.resize(function() {
    var gridSize = $c55bff8fb8cf358b$var$getGridSize();
    $c55bff8fb8cf358b$var$flexslider.vars.minItems = gridSize;
    $c55bff8fb8cf358b$var$flexslider.vars.maxItems = gridSize;
});

})();
//# sourceMappingURL=app.js.map
